// AUTO-GENERATED chunk 'app-idle' by build_bundle.py
// Modules: milestones-view.js, dropdown-handlers.js, mobile-helpers.js, webmcp.js

// ═══ milestones-view.js ═══
;"use strict";
// @ts-nocheck
// §MILESTONES ══════════════════════════════════════════════════════════════════
// ── MILESTONES VIEW (elegant, minimal) ──
//
// P1.2 retire (2026-05-04): typeof OLStorage guards retired here per
// the button-audit P1.2 fix. storage.js loads as a standalone
// <script defer> in dashboard.html BEFORE this bundle's chunk parses,
// so OLStorage is guaranteed defined. Calls in this file rely on
// that load-order invariant. If you reintroduce a typeof guard, you
// likely have a real load-order bug somewhere — investigate
// dashboard.html script ordering instead.
//
// NH9 step 2 (2026-05-07): the auth subsystem extracted to standalone
// auth-handlers.ts; the OLStorage uses left in this file are the
// nudges/trial-end/beta-label readers — same load-order invariant
// applies (storage.js precedes bundle-app-init which precedes
// bundle-app-idle where this file lives).
//
//
// TS Migration Phase 2 PR 54 (2026-05-05): renamed .js → .ts as a
// `// @ts-nocheck` initial rename. 2106 LOC — milestones view +
// usage panel + EPS surprise tables + price targets +
// LEARN Phase 11 mastery integration + 200 strict-mode errors at
// first check (mostly implicit-any handlers + DOM accessor
// narrowings). Cross-chunk surface: showToast, escHtml, fmt, fmtM,
// _isProUser, OLApi, OLStorage, _authUser, etc.
//
// PR 45 A5 empty-state work touches this file's usage-unauth
// branch (calls OLEmpty.render); the migration preserves that
// integration. The `// @ts-nocheck` keeps the OLEmpty cast working
// without requiring a strict-typed fixture for the test gate.
//
// Tighten in PRs 63-65 strict cleanup. The .ts is the SoT;
// milestones-view.js is the gitignored build artifact.
/**
 * CSP-safe inline-style hydrator (Phase 3.D).
 *
 * Supports data-w (width%), data-fg (color), data-bg (background-color),
 * data-bc (border-color), data-h (height%).
 * Call after every innerHTML insertion that contains data-* attrs.
 */
function _hydrateMvStyles(rootEl) {
    if (!rootEl || typeof rootEl.querySelectorAll !== 'function')
        return;
    rootEl.querySelectorAll('[data-w],[data-h],[data-fg],[data-bg],[data-bc]').forEach(function (n) {
        var ds = n.dataset;
        if (ds.w != null)
            n.style.width = ds.w + '%';
        if (ds.h != null)
            n.style.height = ds.h + '%';
        if (ds.fg)
            n.style.color = ds.fg;
        if (ds.bg)
            n.style.backgroundColor = ds.bg;
        if (ds.bc)
            n.style.borderColor = ds.bc;
    });
}
// CYCLE R1 (2026-06-11, OWNER D1): renderMilestonesView RETIRED.
// It was the legacy fallback renderer for ?view=milestones — it read a
// different data shape (static-JSON achievements/desc; never the API),
// hardcoded a stale 75-achievement total, iterated a meta field
// (shareCardWatermarks) that no longer exists, used innerHTML, and
// carried the page's only BRAND glyph violations (U+2713/U+25CB).
// The v3 Honors surface (product/surfaces/achievements.ts) is the ONLY
// renderer; view-router paints an honest retry state on fall-through.
// CYCLE: docs/board/audit/2026-06-11_CYCLE_milestones_design.md.
// ── ANALYST ESTIMATE REVISIONS ── // tier-rename-history: ok (Wall Street equity-analyst forecasts, not the tier slug)
// Dedupe concurrent callers — _lazyPanel('analyst-estimates-panel') can
// fire more than once during a ticker-view load (panel-cascade + direct
// render). Keyed by ticker; cleared in the finally at function end.
var _analystEstimatesInFlight = (typeof _analystEstimatesInFlight !== 'undefined') ? _analystEstimatesInFlight : {};
// "as of Oct 4, 2026 (our fetch date), via FMP" -- the date Oxford Ledge
// fetched the target, labelled as such (OWNER ruling 4 follow-up, 2026-10-04).
function _aeFetchLabel(iso, src) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    var mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var day = m ? mon[Number(m[2]) - 1] + ' ' + Number(m[3]) + ', ' + m[1] : String(iso || '');
    return 'as of ' + escHtml(day) + ' (our fetch date), via ' + escHtml(src);
}
async function renderAnalystEstimates(ticker) {
    if (_analystEstimatesInFlight[ticker]) {
        return _analystEstimatesInFlight[ticker];
    }
    const container = document.getElementById('analyst-estimates-panel');
    if (!container) {
        // Create the panel if it doesn't exist (insert after short-interest or insider panels)
        const anchor = document.getElementById('short-interest-section') || document.getElementById('insider-feed-section');
        if (!anchor)
            return;
        const panel = document.createElement('div');
        panel.id = 'analyst-estimates-panel';
        panel.className = 'ticker-panel';
        panel.classList.add('csp-panel-mt');
        anchor.parentElement.insertBefore(panel, anchor.nextSibling);
        return renderAnalystEstimates(ticker);
    }
    // 2026-04-26: pre-flight tier check. /api/analyst-estimates is
    // require_min_tier("plus"); previously the panel hid itself on
    // 402 so users couldn't see what they were missing. Use TierGate
    // (the canonical tier-rank check) when available — falls back to
    // the simple anonymous check on early-load. Catches both anonymous
    // AND free-tier users who would otherwise still trigger the 402.
    // P1-18 (external review 2026-09-26): an undefined tier while
    // /api/auth/me is in flight is UNKNOWN for a reader not known to be signed
    // out -- fetch, and let the server's 402 (handled below) decide, instead of
    // painting "Sign in to access" over a paying reader's panel. TierGate.canCall
    // applies the same rule; this is the no-TierGate fallback.
    const _tierPending = !window._userTier
        && typeof window.olIsAnonymous === 'function' && window.olIsAnonymous() === false;
    const _isAllowed = _tierPending || ((typeof TierGate !== 'undefined' && TierGate.canCall)
        ? TierGate.canCall('/api/analyst-estimates')
        : ((window._userTier || 'anonymous') !== 'anonymous'));
    if (!_isAllowed) {
        container.classList.remove('hidden');
        var _isAnon = (window._userTier || 'anonymous') === 'anonymous';
        var _ctaLink = _isAnon
            ? '<a href="#" data-action="auth-toggle" class="ol-link-gold">Sign in</a> to access.'
            : '<a href="/?upgrade=plus" class="ol-link-gold">Upgrade to Researcher</a> to unlock.';
        container.innerHTML =
            '<h2 class="panel-title">Analyst Estimates</h2>' +
                '<div class="status-msg--muted ol-pad-v8">EPS surprises, revenue beats and price targets — available on the <a href="/?upgrade=plus" class="ol-link-gold">Researcher</a> tier. ' + _ctaLink + '</div>';
        return;
    }
    container.innerHTML = '<h2 class="panel-title">Analyst Estimates</h2><div class="ce-analyst-count ae-loading-msg">Fetching analyst consensus estimates...</div>';
    _analystEstimatesInFlight[ticker] = (async () => {
        try {
            const res = await fetch(SERVER + '/api/analyst-estimates?ticker=' + encodeURIComponent(ticker), { signal: AbortSignal.timeout(15000) });
            // #112 FE-STORM P2: the pre-flight tier check above catches the common case,
            // but if it passed optimistically and the backend still 402s (tier changed
            // mid-session / stale isAllowed), show the upgrade chip instead of silently
            // hiding the panel. Other !res.ok still hides.
            if (res.status === 402 && typeof TierGate !== 'undefined' && TierGate.renderInlineUpgrade) {
                container.classList.remove('hidden');
                TierGate.renderInlineUpgrade(container, { featureName: 'Analyst estimates', minTier: 'plus' });
                return;
            }
            if (!res.ok) {
                container.classList.add('hidden');
                return;
            }
            const data = await res.json();
            // OWNER ruling 4 (2026-09-28): recommendationTrends (Buy/Hold/Sell counts)
            // is no longer served or rendered, so it no longer keeps the panel open.
            if ((!data.epsSurprises || data.epsSurprises.length === 0) && !data.priceTarget
                && (!data.epsEstimates || data.epsEstimates.length === 0)) {
                container.classList.add('hidden');
                return;
            }
            container.classList.remove('hidden');
            let html = '<h2 class="panel-title">Analyst Estimates</h2>';
            // Coverage honesty (2026-08-22) — PREMISE FALSIFIED, COPY CORRECTED 2026-09-08.
            //
            // The note's original premise, kept here rather than quietly rewritten:
            // "priceTarget + epsEstimates come from Finnhub PREMIUM endpoints our
            // current plan does not carry, so they are null/[] for EVERY ticker."
            // That was TRUE when it shipped (41d1dba4, 2026-08-22) and became FALSE
            // three days later. `321a46a6` (2026-08-25, OWNER-ratified Tier-A lift)
            // revived both legs on the already-paid FMP plan: api/finnhub_api.py:589
            // now short-circuits `if not _finnhub_premium_enabled()` straight into
            // `fmp_analyst_estimates(ticker)`, and the current FMP plan DOES carry
            // both fields (AAPL measured live 2026-09-08: epsEstimates n=10,
            // priceTarget targetMean 339.35).
            //
            // The note could never retire itself. Its stated trigger was
            // OL_FINNHUB_PREMIUM=1, but the data arrived by a different route
            // entirely, so no flag flip was ever going to silence it — the
            // renames-leave-hidden-siblings shape (FOUNDATIONAL
            // feedback_label_renames_leave_hidden_siblings).
            //
            // WHAT IS TRUE NOW: we buy these fields. An empty pair means nobody is
            // forecasting this name, not that we declined to carry the data. PBHC,
            // measured 2026-09-08, returns 16 real epsSurprises rows with
            // epsEstimates:[] and priceTarget:null — so a paying subscriber was told
            // Oxford Ledge does not buy data it does buy, on a plus-tier surface.
            // Distinguishing "no analyst covers this name" from "we do not carry this"
            // is the whole job of this note; it was collapsing them the wrong way.
            //
            // Still deliberately NOT an upgrade link: no in-app tier unlocks a
            // forecast nobody published, and implying otherwise would sell a section
            // no plan can feed. Wording is VOICE's call, not a builder's.
            // Rendered-output contract (executes this emit in node, asserts the
            // string a reader actually sees, both arms):
            //   tests/test_analyst_coverage_note_names_the_right_gap_contract.py
            // Audit: docs/board/audit/2026-09-08_CHAOS_analyst_estimates_premise.md §6.
            if (!data.priceTarget && (!data.epsEstimates || data.epsEstimates.length === 0)) {
                html += '<div class="ae-coverage-note">No analyst currently publishes a price target or forward EPS estimate for this company. That is a gap in analyst coverage, not in what Oxford Ledge carries.</div>';
            }
            // Price target -- OWNER ruling 4 follow-up (2026-10-04): only with its
            // source + the date WE fetched it (the API nulls priceTarget otherwise);
            // no "% upside" (a target against today's price reads as a call).
            const _aePt = data.priceTarget;
            const _aeSrc = _aePt && typeof _aePt.source === 'string' ? _aePt.source.trim() : '';
            const _aeAsOf = _aePt && typeof _aePt.as_of === 'string' ? _aePt.as_of.trim() : '';
            if (_aePt && _aePt.targetMean != null && _aeSrc && _aeAsOf) {
                const pt = _aePt;
                html += '<div class="ae-stat-flex">';
                html += '<div class="ae-stat"><span class="ae-stat-label">TARGET (MEAN)</span><span class="ae-stat-value">$' + Number(pt.targetMean).toFixed(2) + '</span></div>';
                if (pt.targetHigh != null)
                    html += '<div class="ae-stat"><span class="ae-stat-label">HIGH</span><span class="ae-stat-value ae-val-high">$' + Number(pt.targetHigh).toFixed(2) + '</span></div>';
                if (pt.targetLow != null)
                    html += '<div class="ae-stat"><span class="ae-stat-label">LOW</span><span class="ae-stat-value ae-val-low">$' + Number(pt.targetLow).toFixed(2) + '</span></div>';
                const _aeN = Number(pt.numberOfAnalysts);
                if (_aeN > 0 && _aeN === Math.floor(_aeN))
                    html += '<div class="ae-stat"><span class="ae-stat-label">ANALYSTS</span><span class="ae-stat-value">' + _aeN + '</span></div>';
                html += '</div>';
                html += '<div class="ae-stat-sub">' + _aeFetchLabel(_aeAsOf, _aeSrc) + '</div>';
            }
            // EPS Surprises table
            if (data.epsSurprises && data.epsSurprises.length > 0) {
                // 2026-10-05 prod QA (Y2): the SAME series as the Earnings History table
                // (services/eps_history.py), dated by fiscal quarter end, with the
                // SEC-filed EPS beside the vendor's and both bases named below.
                html += '<h3 class="panel-title ae-section-title">EPS Surprise History</h3>';
                html += '<table class="ae-table"><tr><th>Quarter end</th><th>Estimate</th><th>Actual</th><th>Surprise</th><th>SEC EPS</th></tr>';
                let _aeDerived = false;
                for (const s of data.epsSurprises.slice(0, 8)) {
                    if (s.secEps != null && s.secEpsDerived)
                        _aeDerived = true;
                    const surpColor = s.surprise > 0 ? 'var(--text-positive)' : s.surprise < 0 ? 'var(--text-negative)' : 'var(--text-muted)';
                    const surpSign = s.surprise > 0 ? '+' : '';
                    html += '<tr><td>' + escHtml(s.period || '') + (s.dateBasis === 'report_date' ? ' (reported)' : '') + '</td>';
                    html += '<td>$' + (s.estimate != null ? Number(s.estimate).toFixed(2) : '--') + '</td>';
                    html += '<td>$' + (s.actual != null ? Number(s.actual).toFixed(2) : '--') + '</td>';
                    const surpCls = s.surprise > 0 ? 'color-positive' : s.surprise < 0 ? 'color-negative' : 'color-neutral';
                    html += '<td class="' + surpCls + '">' + (s.surprise != null ? surpSign + Number(s.surprise).toFixed(2) + (s.surprisePct != null ? ' (' + surpSign + Number(s.surprisePct).toFixed(1) + '%)' : '') : '--') + '</td>';
                    html += '<td>' + (s.secEps != null ? '$' + Number(s.secEps).toFixed(2) + (s.secEpsDerived ? '*' : '') : '--') + '</td></tr>';
                }
                html += '</table>';
                const _aeMeta = data.epsSurprisesMeta || {};
                html += '<div class="ae-stat-sub">Estimate, actual and surprise: ' + escHtml(String(_aeMeta.source || 'vendor'))
                    + ', analyst basis (typically adjusted, non-GAAP). SEC EPS: diluted, as filed (GAAP)'
                    + (_aeDerived ? '; * fiscal Q4 derived as the year minus Q1-Q3' : '') + '.</div>';
                // Audit M18 (2026-09-24): an "est_revisions" hint here read "Historical
                // estimate revisions available on Research Pro". No such tier exists,
                // and GET /api/estimate-revisions carries no tier dependency
                // (routes/routes_research_fastapi/estimates.py) -- the revisions panel
                // already renders for every reader. Removed: it upsold a free feature.
            }
            // OWNER ruling 4 (2026-09-28): the "Recommendation Trend" Strong Buy /
            // Buy / Hold / Sell bar was removed with the field that fed it.
            container.innerHTML = html;
            _hydrateMvStyles(container);
        }
        catch (e) {
            container.classList.add('hidden');
        }
        finally {
            delete _analystEstimatesInFlight[ticker];
        }
    })();
    return _analystEstimatesInFlight[ticker];
}
function _rotatePulseStrip() {
    const el = document.getElementById('pulse-ticker-strip');
    if (!el || _PULSE_TIPS.length === 0)
        return;
    el.classList.add('opacity-fade', 'opacity-0');
    el.classList.remove('opacity-08');
    setTimeout(() => {
        const tip = _PULSE_TIPS[_pulseStripIdx % _PULSE_TIPS.length];
        let body = tip;
        // Strip legacy "OL Fact: " / "OL Quote: " prefixes from data
        body = body.replace(/^OL (?:Fact|Quote|Tip):\s*/i, '');
        // Detect category from content for label
        const isLedgeReads = /^Ledge Reads:/i.test(body);
        const isQuote = /^[\u201c"]/.test(body) && /\s[-\u2014]\s[A-Z]/.test(body);
        const isFeature = /^Press |^The .* tab |^Click |^Hover |^Visit |^Add |^Set |^Ledge Reads:/.test(body);
        const label = isLedgeReads ? 'READS' : isFeature ? 'TIP' : isQuote ? 'QUOTE' : 'FACT';
        // E1b: inline the (trusted) label markup + escape the leaf values so both
        // interpolations are provably-safe escHtml() calls (label is a constant, so
        // escHtml is a no-op; body was already escaped) — byte-identical output.
        el.innerHTML = `<span class="pulse-strip-inner"><b class="ledge-fact-label">LEDGE ${escHtml(label)}</b> ${escHtml(body)}</span>`;
        el.classList.remove('opacity-0');
        el.classList.add('opacity-08');
        // Scroll if overflows
        setTimeout(() => {
            const inner = el.querySelector('.pulse-strip-inner');
            if (inner && inner.scrollWidth > el.clientWidth) {
                const overflow = inner.scrollWidth - el.clientWidth + 16;
                const duration = Math.max(6, overflow / 30);
                inner.style.animation = 'none';
                inner.offsetHeight;
                inner.style.setProperty('--scroll-dist', `-${overflow}px`);
                inner.style.animation = `pulseScroll ${duration}s linear 2s 1 forwards`;
            }
        }, 100);
        _pulseStripIdx++;
    }, 500);
}
// First rotation triggered by fetch callback (line 7762), interval handles subsequent
registerInterval('pulseStripRotation', _rotatePulseStrip, 15000, true);
// Retry market pulse data after 30s if first attempt was too early (indicators warming up)
setTimeout(() => {
    const pulseEl = document.getElementById('pulse-content');
    // Guarded like every other caller: renderMarketPulse lives in
    // app-renderers.js, a DIFFERENT chunk from this idle one, and a visitor whose
    // proxy blocks or stalls that chunk threw a ReferenceError here 30s after
    // load (Sentry OXFORD-LEDGE-BROWSER-19, 2026-09-23).
    if (typeof renderMarketPulse === 'function' && pulseEl
        && (!pulseEl.children.length || pulseEl.textContent.includes('Loading'))) {
        renderMarketPulse();
    }
}, 30000);
// ═══ PREMIUM DATA NUDGES (subtle, non-blocking) ═══
// Audit M1/M7 (2026-09-24): was `tier === 'pro' || tier === 'scale'`, which
// read Power User, Advisor and Institutional as NOT premium. Now Investor rank
// or above on the server ladder (tier-gate.ts OL-TIER-RANK-HELPERS). It has no
// in-tree caller left: the hint helper below keys on Researcher rank (every
// hint it renders is a plus-gated surface) and the ticker real-time nudge calls
// _olTierAtLeast('pro') directly. Kept for any cross-chunk/template reader.
function _isPremiumUser() {
    return typeof _olTierAtLeast === 'function' ? _olTierAtLeast('pro') : false;
}
function _premiumNudgeDismissed(key) {
    try {
        return OLStorage.getString('ol_nudge_' + key, null) === '1';
    }
    catch (e) {
        return false;
    }
}
function _dismissPremiumNudge(key, el) {
    try {
        OLStorage.setString('ol_nudge_' + key, '1');
    }
    catch (e) { }
    if (el) {
        const hint = el.closest('.premium-hint');
        if (hint)
            hint.remove();
    }
}
function _makePremiumHint(key, text, opts) {
    // Every hint this renders advertises a Researcher-gated surface (earnings
    // transcripts -- require_min_tier("plus") server-side; the screener-filter
    // and bond-database hints went with the client caps on 2026-09-24), so any
    // tier at Researcher rank or above already has the thing and must not be
    // nudged. Was _isPremiumUser() (pro/scale), which nudged paying Researchers
    // toward what they own.
    var _hasIt = typeof _olTierAtLeast === 'function' ? _olTierAtLeast('plus') : false;
    if (_hasIt || _premiumNudgeDismissed(key))
        return '';
    // CYCLE5 CSP fix: convert opts.style inline injection to utility classes.
    var cls = (opts && opts.inline) ? 'premium-hint premium-hint--inline' : 'premium-hint';
    if (opts && opts.style) {
        if (opts.style.indexOf('margin-top') >= 0)
            cls += ' premium-hint--mt-tight';
        if (opts.style.indexOf('margin-bottom') >= 0)
            cls += ' premium-hint--mb-loose';
    }
    return '<div class="' + cls + '">' + text +
        ' <span class="premium-hint-dismiss" data-action="dismiss-premium-nudge" data-nudge-key="' + key + '" title="Dismiss">&times;</span></div>';
}
// ═══ FEATURE GATING (subtle free-tier limits) ═══
function _getUserTier() {
    if (_billingData && _billingData.tier)
        return _billingData.tier.toLowerCase();
    try {
        const t = OLStorage.getString('ol_user_tier', null);
        if (t)
            return t.toLowerCase();
    }
    catch (e) { }
    return 'hobbyist'; // default free
}
// Audit M1 (2026-09-24): `_isProUser()` was `t === 'pro' || t === 'scale'`
// and was the gate on the FREE_TIER_LIMITS client caps, so a paying Researcher,
// an active trial, Power User, Advisor and Institutional all kept free caps.
// Every in-tree caller now asks the question it actually means through
// `_olTierAtLeast(<tier>)` (tier-gate.ts OL-TIER-RANK-HELPERS, the server's
// middleware/auth.py _TIER_ORDER ladder) -- see the classification table in
// the 2026-09-24 builder hand-off. This name is kept for cross-chunk readers
// and now means what it says, "Investor rank or above": pro and legacy scale
// stay true, and professional / team / institutional_plus / an active pro
// trial become true too (they rank above or equal to Investor server-side).
function _isProUser() { return typeof _olTierAtLeast === 'function' ? _olTierAtLeast('pro') : false; }
function _isScaleUser() { return _getUserTier() === 'scale'; }
// P0 incident fix 2026-05-13: expose `_isProUser` + `_getUserTier` on
// window so early-boot consumers in OTHER bundle chunks can call them
// safely. Per memory/feedback_module_top_level_global_race:
// milestones-view.js was moved to the `app-idle` chunk in NH9 step 2
// (2026-05-07) — loads as <script defer fetchpriority="low"> LAST.
// Before that move, `addTickerBySymbol` (in `bundle-app-tail`) and
// other early-init callers shared a bundle scope with this function.
// After the split, bare `_isProUser()` calls from `bundle-app-init` /
// `bundle-app-tail` fail at runtime with "ReferenceError: _isProUser
// is not defined" because the symbol is in a not-yet-loaded chunk.
// Repro: navigate to /?view=ticker&symbol=AAPL → addTickerBySymbol at
// init time → unresolved bare reference. Defense: expose to window so
// the defensive `typeof w._isProUser === 'function'` pattern in
// bdc-view.ts:135 (and similar guards added in this fix) actually
// finds the function. Callers MUST use the window-prefixed form +
// fail-safe fallback to "assume free tier" when the function isn't
// yet available.
try {
    const w = window;
    if (typeof w._isProUser !== 'function')
        w._isProUser = _isProUser;
    if (typeof w._isScaleUser !== 'function')
        w._isScaleUser = _isScaleUser;
    if (typeof w._getUserTier !== 'function')
        w._getUserTier = _getUserTier;
}
catch (_e) { /* SSR / no-window context */ }
// The client-side free-tier caps (and the screener "up to 3 filter groups"
// hint that advertised one of them) were removed on 2026-09-24 (OWNER,
// SF-MONETIZATION-V3): no tier has a ticker, portfolio, filter, 13F-holder or
// bond-result cap in the browser any more.
// ═══ USAGE & BILLING PANEL ═══
var _billingData = null; // cached billing data from server
// OWNER 2026-09-24 "Developer = Power User + a monthly API allowance": the
// display name of the ACTIVE Developer plan /api/billing/usage reports in
// `agent_plan` (services/billing/constants.py AGENT_API_PLANS names), or ''.
function _mvAgentPlanName(plan) {
    if (plan === 'developer_pro')
        return 'Developer Pro';
    if (plan === 'developer')
        return 'Developer';
    return '';
}
// _billingRefreshInterval removed #22 (2026-06-18): billing refresh now runs
// through OLPolling (key milestones:billing), de-duped by key + torn down by
// the generic setView clearByKeyPrefix('milestones:') — no raw timer handle.
// S35 audit #53b: centralized tier config from server (single source of truth)
var _tierConfig = null; // populated from /api/billing/tiers
// F4.1 (SF-23 audit 2026-05-07): _TIER_FALLBACK is defense-in-depth for
// when /api/billing/tiers can't be reached. Pre-fix every limit and
// price was stale relative to the live TIER_CONFIG at
// services/billing/constants.py:131-146 (free 3000->5000, plus
// 10000->20000, pro 20000->unlimited, plus also $9 not $29). Fixing
// here so a network failure on boot doesn't leave the user staring at
// numbers 40-80% off the marketing.
var _TIER_FALLBACK = {
    // bundled_credits mirrors services/billing/constants.py TIER_CONFIG
    // (the /api/billing/tiers source). It is the per-tier card's only
    // customer-facing number post-lookup-retirement; keep in sync on the
    // rare network-failure fallback path so the cards aren't blank.
    free: { name: 'Learner', price_mo: 0, limit: 5000, display_limit: '5,000/mo', bundled_credits: 10 },
    // 2.3 (2026-06-12): the names below are the no-API fallback only and
    // are PINNED equal to the backend canon by test_tier_vocab_canon_contract
    // (the live path reads /api TIER_CONFIG, whose names share the canon).
    plus: { name: 'Researcher', price_mo: 9, price_yr: 81, limit: 20000, display_limit: '20,000/mo', bundled_credits: 200 },
    pro: { name: 'Investor', price_mo: 19, price_yr: 171, limit: 9999999, display_limit: 'Unlimited', bundled_credits: 500 },
    professional: { name: 'Power User', price_mo: 29, price_yr: 261, limit: 9999999, display_limit: 'Unlimited', bundled_credits: 1000 },
};
function _getTierConfig() { return _tierConfig || _TIER_FALLBACK; }
(function () {
    fetch('/api/billing/tiers').then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.tiers)
            _tierConfig = d.tiers;
    }).catch(function () { });
})();
// Bug #12 fix: Refresh billing data every 5 minutes so tier changes
// (upgrades, downgrades, trial expiry) are reflected without page reload.
function _startBillingRefresh() {
    // #22 (audit 2026-06-18): via OLPolling — hidden-pause + 3-slot cap + de-dup.
    // Was a raw 5-min setInterval, never cleared + no hidden guard (fetched
    // billing in the background forever after one visit to milestones). Keyed
    // milestones:billing so the generic setView teardown clears it on view-leave;
    // OLPolling de-dups by key so no re-entry guard is needed.
    if (typeof OLPolling === 'undefined' || !OLPolling)
        return;
    OLPolling.create({ key: 'milestones:billing', intervalMs: 5 * 60 * 1000, maxIterations: 1e9, onTick: function () {
            if (typeof _authUser !== 'undefined' && _authUser) {
                fetchBillingData();
            }
        } });
}
function _usageLevel(pct) {
    if (pct >= 95)
        return 'danger';
    if (pct >= 80)
        return 'warn';
    return 'ok';
}
function _formatCompact(n) {
    if (n >= 1000000)
        return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (n >= 1000)
        return (n / 1000).toFixed(n >= 10000 ? 0 : 1).replace(/\.0$/, '') + 'K';
    return String(n);
}
function _daysRemaining(periodEnd) {
    if (!periodEnd)
        return null;
    const end = new Date(periodEnd);
    const now = new Date();
    const diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
    return Math.max(0, diff);
}
async function fetchBillingData() {
    try {
        const data = await window.OLApi.getBillingUsage();
        _billingData = data;
        // Phase 1: Sync tier globals when usage response reports a different tier.
        // Catches trial expiry + background tier changes that happen without a
        // page reload — the 5-min refresh interval now propagates to premium-gate
        // + TierGate instead of only updating the usage panel.
        // Never-hang (OWNER prod-QA 2026-07-15): `_billingData` is already cached
        // above, so the panel CAN hydrate — but a throw in any COSMETIC side-effect
        // below used to bubble to the catch → `return null`, and the
        // renderUsageView().then(if(d)) gate then skipped the re-render even though
        // the data was in hand. These are display-only (tier-sync, status-bar
        // counter, auth-dropdown cap, nudge banner, refresh backstop); none may
        // block the panel from painting data we already have. Contain each so
        // `return data` ALWAYS fires on a successful fetch.
        try {
            if (data.tier && data.tier !== window._userTier) {
                var oldTier = window._userTier;
                window._userTier = data.tier;
                try {
                    window.dispatchEvent(new CustomEvent('ol-tier-changed', { detail: { tier: data.tier, previous: oldTier } }));
                }
                catch (_) { }
            }
        }
        catch (_) { /* tier-sync is best-effort */ }
        try {
            _updateStatusBarUsage(data);
        }
        catch (_) { /* cosmetic */ }
        try {
            _updateAuthDropdownCap(data);
        }
        catch (_) { /* cosmetic */ }
        try {
            _showUsageNudge(data);
        }
        catch (_) { /* cosmetic */ }
        try {
            _startBillingRefresh();
        }
        catch (_) { /* refresh backstop */ }
        return data;
    }
    catch (_) {
        return null;
    }
}
function _showUsageNudge(data) {
    // Remove any existing nudge
    const existing = document.getElementById('usage-nudge-banner');
    if (existing)
        existing.remove();
    if (!data || !_authUser)
        return;
    // (The usage/limit percentage this used to compute fed only the retired
    // research-allowance branches removed below -- audit M18, 2026-09-24.)
    const tier = (data.tier || 'free').toLowerCase();
    const graceDays = data.grace_remaining_days;
    // F4.6 (SF-23 audit 2026-05-07): trial-end countdown within 48h.
    // Pre-fix the backend computed trial_expired / grace_period_active /
    // grace_remaining_days but the frontend only rendered graceDays. A
    // user 24h from trial expiry got no countdown — the platform looked
    // fine right up until access flipped. This branch sits between
    // graceDays (already-failed-payment, danger) and tier=free usage
    // warnings (no-trial-context, warn): when trial_end is in the next
    // 48 hours, surface a warn-level banner with a portal CTA.
    const trialEndStr = data.trial_end;
    let trialHoursLeft = null;
    if (trialEndStr) {
        const trialDate = new Date(trialEndStr);
        if (!isNaN(trialDate.getTime())) {
            trialHoursLeft = (trialDate.getTime() - Date.now()) / (1000 * 60 * 60);
        }
    }
    let msg = '', level = '';
    // Grace period warning (highest priority)
    if (graceDays != null && graceDays >= 0) {
        msg = 'Payment issue detected. ' + (graceDays > 0 ? graceDays + ' day' + (graceDays > 1 ? 's' : '') + ' remaining before service interruption.' : 'Grace period expired. Please update your payment method.');
        level = 'danger';
    }
    else if (trialHoursLeft != null && trialHoursLeft > 0 && trialHoursLeft <= 48) {
        // F4.6: trial-end < 48h. Copy mirrors SF-23 audit doc template.
        const tierName = (data.tier_display || tier).replace(/^\w/, (c) => c.toUpperCase());
        if (trialHoursLeft <= 24) {
            const hoursRounded = Math.max(1, Math.round(trialHoursLeft));
            msg = 'Trial ends in ' + hoursRounded + ' hour' + (hoursRounded > 1 ? 's' : '') + '. Add a payment method to keep ' + tierName + ' features.';
        }
        else {
            msg = 'Trial ends in 1 day. Add a payment method to keep ' + tierName + ' features.';
        }
        level = 'warn';
    }
    // Audit M18 (2026-09-24): two further branches lived here -- "You've used N%
    // of your free tier research allowance. Upgrade to Research Pro for unlimited
    // company analysis." and "... Consider upgrading to Pro for uninterrupted
    // access." Both were false three ways: there is no "Research Pro" tier; the
    // research allowance they measured is RETIRED (TIER_CONFIG lookups_unlimited
    // on every tier -- the usage counter is tracked, never enforced,
    // services/billing/usage.py check_budget_detail); and they keyed on the
    // legacy tier name 'hobbyist', which TIER_MIGRATION rewrites to 'free' before
    // the client ever sees it. Removed, with their start-checkout CTA below.
    if (!msg)
        return;
    const colors = {
        warn: { bg: 'rgba(240,165,0,0.12)', border: 'rgba(240,165,0,0.3)', text: 'var(--amber)', btn: 'var(--amber)' },
        danger: { bg: 'rgba(212,115,31,0.12)', border: 'rgba(212,115,31,0.3)', text: 'var(--alert-text)', btn: 'var(--alert-text)' }
    };
    const c = colors[level];
    const banner = document.createElement('div');
    banner.id = 'usage-nudge-banner';
    banner.className = 'csp-nudge-banner';
    banner.style.setProperty('--nudge-bg', c.bg);
    banner.style.setProperty('--nudge-border', c.border);
    banner.style.setProperty('--nudge-text', c.text);
    // F4.6: trial-end branch routes the CTA to billing portal (not checkout).
    // The grace-period branch has no CTA button (its copy names the fix).
    const isTrialBranch = trialHoursLeft != null && trialHoursLeft > 0 && trialHoursLeft <= 48 && (graceDays == null || graceDays < 0);
    let ctaHtml = '';
    if (isTrialBranch) {
        ctaHtml = '<button data-action="open-billing-portal" class="nudge-upgrade-btn mv-nudge-upgrade-btn" data-bg="' + c.btn + '">Manage billing</button>';
    }
    banner.innerHTML = '<span>' + escHtml(msg) + '</span>'
        + ctaHtml
        + '<button data-action="nudge-close" class="nudge-close-btn mv-nudge-close-btn" data-fg="' + c.text + '">&times;</button>';
    _hydrateMvStyles(banner);
    document.body.prepend(banner);
}
function _updateStatusBarUsage(data) {
    const el = document.getElementById('sb-usage-counter');
    if (!el)
        return;
    if (!data || !_authUser) {
        el.classList.add('hidden');
        return;
    }
    const usage = data.usage || 0;
    // F4.1: status-bar usage-counter fallback. See _maybeShowUsageNudge for
    // the full audit-trail comment.
    const _olFreeLimit = window.OL_FREE_TIER_LIMIT || 5000;
    const limit = data.limit || _olFreeLimit;
    const pct = (usage / limit) * 100;
    const level = _usageLevel(pct);
    el.textContent = _formatCompact(usage) + '/' + _formatCompact(limit);
    el.className = 'sb-usage-btn sb-usage-' + level;
    el.classList.remove('hidden');
}
function _updateAuthDropdownCap(data) {
    const capEl = document.getElementById('auth-dd-cap');
    if (capEl) {
        if (data && data.cap != null) {
            capEl.textContent = 'Cap: $' + Number(data.cap).toFixed(2) + '/mo';
        }
        else {
            capEl.textContent = '';
        }
    }
    // F3.3 (SF-23 audit 2026-05-07): default tier was 'hobbyist' (legacy
    // name). TIER_MIGRATION at services/billing/constants.py:202 maps
    // 'hobbyist' -> 'free', so the live tier value for an unauthenticated
    // user (or a fetch-failure fallback) is 'free', NEVER 'hobbyist'. The
    // pre-fix default leaked through the portal-button visibility check
    // (portalBtn hidden iff tier === 'hobbyist') and left the Manage
    // Billing button visible for every free user — clicking it routed
    // through _openBillingPortal which silently bounced to
    // showPremiumGate('billing'). Trust dent on the most billing-sensitive
    // surface. Default changed to 'free' to match the live key set; the
    // visibility checks below treat both as equivalent (dual-key compat
    // until TIER_MIGRATION is fully retired).
    const tier = (data && data.tier) ? data.tier.toLowerCase() : 'free';
    // Show/hide portal link for paid subscribers (F3.3: include 'free' to
    // mirror the trial-CTA gate at line 515; was 'hobbyist'-only).
    const portalBtn = document.getElementById('auth-dd-portal-btn');
    if (portalBtn) {
        portalBtn.classList.toggle('hidden', tier === 'hobbyist' || tier === 'free');
    }
    // Show 7-day trial CTA for free/hobbyist tier users
    const trialCta = document.getElementById('auth-dd-trial-cta');
    if (trialCta) {
        const wasHidden = trialCta.classList.contains('hidden');
        const shouldHide = tier !== 'hobbyist' && tier !== 'free';
        trialCta.classList.toggle('hidden', shouldHide);
        // 2026-04-30 evening (auth-panels A9): instrument the auth-
        // dropdown trial CTA with paired show + click telemetry so we
        // can measure CTR. Pre-fix neither event fired — the audit
        // assumed click was wired but it wasn't either. Pattern matches
        // tier-gate.js:259 (provider_banner_shown / _dismissed pair)
        // and the 2026-04-30 PM provider-banner instrumentation. Show
        // event fires only on the wasHidden → visible transition so
        // reopening the dropdown doesn't double-count. Click event
        // wires once via dataset guard so re-render doesn't multi-bind.
        if (wasHidden && !shouldHide) {
            try {
                if (typeof _track === 'function')
                    _track('auth_dd_trial_cta_shown', { tier: tier });
            }
            catch (_e) { /* telemetry must never break the CTA render */ }
        }
        if (!trialCta.dataset.olA9TrackBound) {
            trialCta.dataset.olA9TrackBound = '1';
            trialCta.addEventListener('click', function () {
                try {
                    if (typeof _track === 'function')
                        _track('auth_dd_trial_cta_click', { tier: window._userTier || 'unknown' });
                }
                catch (_e) { /* telemetry must never break navigation */ }
            });
        }
    }
    // 2026-05-19 P0-4 (5-persona quorum CHAMP #1 + CHAOS C2; OWNER-ratified
    // placement: auth-dd row, NOT topstrip banner — "less clunkiness").
    // In-app trial-cliff countdown. Surfaces when the user is currently
    // mid-trial (`plus_trial`/`pro_trial`) and `data.trial_end` is in the
    // future. Visual emphasis at T-3 days or fewer via the `urgent` class.
    // Pairs with the existing T-3/T-2/T-1 email reminders (services/
    // email_service.py:1566+) to close the in-app silence gap CHAMP
    // walkthrough surfaced (user who has email filtered hit the cliff cold).
    const trialStatus = document.getElementById('auth-dd-trial-status');
    const trialStatusLabel = document.getElementById('auth-dd-trial-status-label');
    if (trialStatus && trialStatusLabel) {
        // 2026-06-02 (OWNER "unable to sign out"): authSignOut -> authUpdateUI ->
        // _updateAuthDropdownCap(null) threw "Cannot read properties of null
        // (reading 'trial_end')" here — the .cap/.tier reads above are null-guarded
        // but this one wasn't, so sign-out aborted (and re-firing /api/auth/logout
        // on each retry). Guard the null (signed-out) case.
        const trialEndStr = data ? data.trial_end : undefined;
        let daysLeft = null;
        if (trialEndStr && (tier === 'plus_trial' || tier === 'pro_trial')) {
            const trialDate = new Date(trialEndStr);
            if (!isNaN(trialDate.getTime())) {
                daysLeft = Math.max(0, Math.ceil((trialDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
            }
        }
        if (daysLeft != null) {
            const label = daysLeft === 0 ? 'Trial ends today' :
                daysLeft === 1 ? 'Trial ends tomorrow' :
                    'Trial: ' + daysLeft + ' days left';
            trialStatusLabel.textContent = label;
            trialStatus.classList.toggle('urgent', daysLeft <= 3);
            trialStatus.classList.remove('hidden');
        }
        else {
            trialStatus.classList.add('hidden');
        }
    }
}
function _toggleCapOptions() {
    const wrap = document.getElementById('usage-cap-options');
    if (wrap)
        wrap.classList.toggle('open');
}
async function _setUsageCap(amount) {
    if (!_billingData)
        _billingData = {};
    _billingData.cap = amount;
    _updateAuthDropdownCap(_billingData);
    renderUsageView();
    // Persist to server
    try {
        const res = await fetch('/api/billing/set-cap', {
            method: 'POST',
            headers: _csrfHeaders(),
            credentials: 'same-origin',
            body: JSON.stringify({ cap: amount })
        });
        if (res.ok) {
            showToast('Safety cap set to $' + Number(amount).toFixed(2) + '/mo', 'success', 3000);
        }
        else {
            const err = await res.json().catch(() => ({}));
            showToast(err.error || 'Unable to save spending cap. Please try again.', 'warning', 3000);
        }
    }
    catch (_) {
        showToast('Safety cap updated locally (server unavailable)', 'warning', 3000);
    }
}
async function _startCheckout(tier, period) {
    try {
        // 2.3 / P3-A10 (2026-06-12): translate legacy alias slugs at the POST
        // boundary — the backend allowlist accepts canonical keys only, so a
        // shared /?signup=1&upgrade=pro-ai link sailed through signup then
        // 400'd HERE. One boundary, every entry path covered.
        if (tier === 'pro-ai' || tier === 'plus_ai')
            tier = 'professional';
        showToast('Redirecting to checkout...', '', 2000);
        const res = await fetch('/api/billing/create-checkout', {
            method: 'POST',
            headers: _csrfHeaders(),
            credentials: 'same-origin',
            body: JSON.stringify({ tier: tier || 'pro', period: period || 'monthly' })
        });
        // 2026-06-19 audit Phase-3 [Med]: a logged-out upgrade tap 401'd here and
        // dead-ended on a "Unable to start checkout" toast. Route to signup with
        // upgrade intent so checkout RESUMES post-signup via the existing
        // ?upgrade= path (see the alias-translation comment above).
        if (res.status === 401) {
            window.location.href = '/?signup=1&upgrade=' + encodeURIComponent(tier || 'pro');
            return;
        }
        const data = await res.json();
        if (data.url) {
            window.location.href = data.url;
        }
        else {
            showToast(data.error || 'Unable to start checkout. Please try again in a moment.', 'warning', 4000);
        }
    }
    catch (e) {
        showToast('Unable to reach checkout. Please try again in a moment.', 'warning', 4000);
    }
}
// #418: conversion-funnel "cancel_reason" emit. The subscription cancel
// itself happens inside the Stripe Customer Portal (out of our reach — Stripe
// never surfaces the reason to us). The in-app affordance that PRECEDES the
// portal redirect is _openBillingPortal(); per the issue's design we attach a
// small optional exit-reason picker there. Posting via sendBeacon (Blob
// tagged application/json so the body arrives as JSON) keeps it best-effort
// and survives the immediate portal navigation.
function _emitCancelReason(reason) {
    try {
        var payload = JSON.stringify({ event: 'cancel_reason', details: { reason: reason } });
        if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
            var blob = new Blob([payload], { type: 'application/json' });
            navigator.sendBeacon('/api/billing/funnel-event', blob);
            return;
        }
        if (typeof fetch === 'function') {
            void fetch('/api/billing/funnel-event', {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: payload,
                credentials: 'same-origin',
                keepalive: true,
            }).catch(function () { });
        }
    }
    catch (_e) { /* analytics is best-effort */ }
}
// Brand-compliant exit-reason picker (BRAND.md: square corners, no emoji,
// sentence-case, patient editorial register). Shown once before the portal
// redirect for paid users; the user may pick a reason (emits cancel_reason)
// or continue straight to billing. The picker is OPTIONAL friction — it never
// blocks the user from reaching the portal. Returns a Promise that resolves
// when the user has chosen to continue (so the caller proceeds to the portal).
var _cancelReasonPickerShown = false;
function _showCancelReasonPicker() {
    return new Promise(function (resolve) {
        // Square-cornered hairline-bordered overlay (brand layout primitives).
        //
        // #119 (2026-08-14): the presentation moved to dashboard-styles.css
        // (.ol-cancel-reason-*). It was authored here as `.style.x = ...` to be
        // CSP-safe -- and it is -- but a JS-set style is invisible to EVERY CSS
        // gate in the tree, and that is how this card shipped painting
        // `var(--surface, #fff)` against `var(--text)` = --text-primary. In the
        // default dark theme that is #e8edf2 on #ffffff: a contrast ratio of
        // 1.18:1, i.e. the heading and body of the cancellation prompt were
        // effectively invisible. A real stylesheet rule is equally CSP-clean and
        // is actually SCANNED. Classes were already on every node, so this is a
        // move, not a rewrite.
        var overlay = document.createElement('div');
        overlay.className = 'ol-cancel-reason-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-label', 'Before you manage your subscription');
        var card = document.createElement('div');
        card.className = 'ol-cancel-reason-modal';
        var heading = document.createElement('div');
        heading.className = 'ol-cancel-reason-heading';
        heading.textContent = 'Before you go';
        var sub = document.createElement('div');
        sub.className = 'ol-cancel-reason-sub';
        sub.textContent = 'If you are thinking of cancelling, a quick note on why helps us improve. This is optional.';
        var chipRow = document.createElement('div');
        chipRow.className = 'ol-cancel-reason-chips';
        // Sentence-case reasons, no emoji (brand iconography rule).
        var reasons = [
            'Too expensive',
            'Not using it enough',
            'Missing a feature I need',
            'Found an alternative',
            'Just exploring',
            'Other',
        ];
        var done = false;
        function _finish() {
            if (done)
                return;
            done = true;
            try {
                if (overlay.parentNode)
                    overlay.parentNode.removeChild(overlay);
            }
            catch (_e) { }
            resolve();
        }
        reasons.forEach(function (r) {
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'ol-cancel-reason-chip';
            chip.textContent = r;
            chip.addEventListener('click', function () {
                _emitCancelReason(r);
                _finish();
            });
            chipRow.appendChild(chip);
        });
        var actions = document.createElement('div');
        actions.className = 'ol-cancel-reason-actions';
        var skipBtn = document.createElement('button');
        skipBtn.type = 'button';
        skipBtn.className = 'ol-cancel-reason-skip';
        skipBtn.textContent = 'Continue to billing';
        skipBtn.addEventListener('click', function () { _finish(); });
        actions.appendChild(skipBtn);
        card.appendChild(heading);
        card.appendChild(sub);
        card.appendChild(chipRow);
        card.appendChild(actions);
        overlay.appendChild(card);
        // Click outside the card = continue without a reason.
        overlay.addEventListener('click', function (ev) {
            if (ev.target === overlay)
                _finish();
        });
        document.body.appendChild(overlay);
    });
}
async function _openBillingPortal() {
    // Free-tier users have no Stripe customer record yet — the portal
    // call would 400 with "no active subscription". 2026-04-26 v2: was
    // sending to '/pricing' (the cliff). Now opens the in-app upgrade
    // flow via showPremiumGate('billing') so the user stays in the SPA.
    // showPremiumGate falls back to '/?upgrade=plus' if not loaded.
    var tier = (_authUser && (_authUser.tier || (_billingData && _billingData.tier))) || window._userTier || 'free';
    if (tier === 'free' || tier === 'anonymous' || !tier) {
        // P1-16 (2026-09-26): 'billing' resolves to the Researcher overlay in
        // premium-gate.ts; if nothing opens, go to /pricing rather than do nothing.
        if (typeof window.showPremiumGateResult === 'function') {
            if (window.showPremiumGateResult('billing') === 'unknown')
                window.location.href = '/pricing';
        }
        else if (typeof window.showPremiumGate === 'function') {
            window.showPremiumGate('billing');
        }
        else {
            window.location.href = '/?upgrade=plus';
        }
        return;
    }
    // #418: paid users heading to the portal (where cancel lives) see the
    // optional exit-reason picker once per page session. Picking a reason
    // emits cancel_reason; it never blocks the portal redirect.
    if (!_cancelReasonPickerShown) {
        _cancelReasonPickerShown = true;
        try {
            await _showCancelReasonPicker();
        }
        catch (_e) { }
    }
    try {
        showToast('Opening subscription management...', '', 2000);
        const res = await fetch('/api/billing/portal', {
            method: 'POST',
            headers: _csrfHeaders(),
            credentials: 'same-origin',
            body: '{}'
        });
        const data = await res.json().catch(function () { return {}; });
        if (data.url) {
            window.location.href = data.url;
            return;
        }
        // #108 (OWNER prod-QA 2026-06-03): comp / admin / founder accounts are
        // high-tier with no Stripe customer, so the portal can't open. The backend
        // returns a calm 200 {reason:'no_billing_account', message} (NOT a 400) for
        // exactly this case. Show the explanation as a neutral note — a comp
        // account has nothing to manage and should NOT be told to "email support".
        if (data.reason === 'no_billing_account') {
            showToast(data.message || 'This is a complimentary account — there is no billing to manage.', '', 5000);
            return;
        }
        // Non-success: give an HONEST, status-specific message. #72 (2026-06-02):
        // on a live session the portal was returning 429/403/400 and every status
        // fell through to the generic "subscription record could not be loaded",
        // which misreads a rate-limit / auth issue as a missing subscription — the
        // button looked dead and the user re-clicked (compounding the 429).
        var msg;
        if (res.status === 429) {
            msg = 'Too many requests right now — please wait a moment, then try again.';
        }
        else if (res.status === 403) {
            msg = 'Your session needs a refresh to manage billing. Reload the page, then try again.';
        }
        else if (res.status === 400) {
            // Paid tier but no Stripe customer (rare: trial-only / staff comp /
            // Stripe customer purged).
            msg = 'No active subscription found for this account. If you believe this is an error, email support@oxfordledge.com.';
        }
        else {
            msg = data.error || 'Your subscription record could not be loaded. Please try again in a moment.';
        }
        showToast(msg, 'warning', 8000);
    }
    catch (e) {
        showToast('Unable to reach billing portal. Please try again in a moment.', 'warning', 6000);
    }
}
function _setCustomCap() {
    const inp = document.getElementById('usage-cap-custom-input');
    if (!inp)
        return;
    const val = parseFloat(inp.value);
    if (isNaN(val) || val < 1) {
        showToast('Enter a valid amount ($1 minimum)', 'warning', 3000);
        return;
    }
    _setUsageCap(val);
}
// F4.4 (SF-23 audit 2026-05-07): Activity breakdown — per-action
// usage rollup populated from /api/billing/usage/breakdown. Section
// stays hidden when the user has no events (new account state) so
// we don't show a 'No activity yet' card on the very first session.
function _humanizeAction(action) {
    // Map an endpoint path to a friendly label. Keep simple — falls back
    // to the path itself when no match.
    const map = {
        '/api/screener': 'Stock Screener',
        '/api/run-screener': 'Stock Screener',
        '/api/portfolio-analytics': 'Portfolio Analytics',
        '/api/13f': '13F Holdings',
        '/api/data': 'Stock Data',
        '/api/fundamentals': 'Company Financials',
        '/api/bdc': 'BDC Holdings',
        '/api/credit': 'Credit / Bonds',
        '/api/options': 'Options Chain',
        '/api/ai/chat': 'AI Chat',
        '/api/ai/ask': 'AI Chat',
        '/api/news': 'News',
        '/api/headlines': 'News',
        '/api/search': 'Search',
        '/api/peers': 'Peer Comparison',
        '/api/transcript': 'Earnings Transcripts',
        '/api/insider': 'Insider Trades',
        '/api/etf': 'ETF Holdings',
        '/api/ticker': 'Ticker Lookup',
        '/api/bond': 'Bond Lookup',
    };
    for (const prefix in map) {
        if (action && action.indexOf(prefix) === 0)
            return map[prefix];
    }
    return action || 'Other';
}
function _renderUsageBreakdown() {
    const section = document.getElementById('usage-breakdown-section');
    const bars = document.getElementById('usage-breakdown-bars');
    if (!section || !bars)
        return;
    fetch('/api/billing/usage/breakdown', { credentials: 'same-origin' })
        .then(function (r) {
        if (!r.ok)
            throw new Error('HTTP ' + r.status);
        return r.json();
    })
        .then(function (data) {
        if (!data || !data.items || data.items.length === 0 || data.total_quantity === 0) {
            // No activity yet — keep the section hidden so the usage view
            // doesn't show an awkward empty card to a brand-new user.
            return;
        }
        // 2026-06-09 (OWNER): this panel is "AI Activity" and must reconcile with
        // the AI-credit pill. The Slice-F middleware records `api_read` on EVERY
        // authed data read, which dominated the panel (1,385 reads at 100%) and
        // contradicted "AI: 0" — making it look like data viewing ate the AI
        // budget. It does NOT: per usage.py the AI-credit `credit_balance` is the
        // sole AI gate, while `current_month_usage` (api_read/CRUD) is display-
        // only analytics that never decrements credits. Exclude those non-AI
        // data/CRUD actions so the panel honestly shows AI usage only.
        var _NON_AI_ACTIONS = {
            'api_read': 1, 'watchlist_mutate': 1, 'portfolio_mutate': 1,
            'data_read': 1, 'lookup': 1,
        };
        var _aiItems = data.items.filter(function (it) {
            return !_NON_AI_ACTIONS[it.action];
        });
        if (_aiItems.length === 0) {
            return; // only non-AI data reads → keep the AI panel hidden (coherent with AI: 0)
        }
        // Coalesce into friendly labels (multiple endpoint prefixes can
        // map to the same UX bucket — sum them). Percentages are AI-relative.
        const buckets = {};
        let total = 0;
        for (const item of _aiItems) {
            const label = _humanizeAction(item.action);
            if (!buckets[label])
                buckets[label] = 0;
            buckets[label] += item.total_quantity;
            total += item.total_quantity;
        }
        const sorted = Object.keys(buckets).map(function (k) {
            return { label: k, qty: buckets[k] };
        }).sort(function (a, b) { return b.qty - a.qty; });
        // Render up to 8 bars (chart fits in the panel without scroll).
        const top = sorted.slice(0, 8);
        let html = '';
        for (const row of top) {
            // OWNER prod-QA 2026-05-26: a zero-count row was rendering "(1%)"
            // because Math.max(1, …) forced a 1% floor on the displayed pct.
            // The floor matters for VISUAL BAR WIDTH (a 1-event row at 0.1%
            // should still render as a visible sliver), not for the LABEL.
            // Split the two so 0-count rows show "0 (0%)" correctly while a
            // 1+-event row still gets at least 1% width for the bar.
            const rawPct = total > 0 ? Math.round((row.qty / total) * 100) : 0;
            const barPct = row.qty > 0 ? Math.max(1, rawPct) : 0;
            const pct = rawPct;
            html += '<div class="usage-breakdown-row">' +
                '<div class="usage-breakdown-label">' + escHtml(row.label) + '</div>' +
                '<div class="usage-breakdown-bar-track">' +
                '<div class="usage-breakdown-bar-fill mv-usage-bar-fill" data-w="' + pct + '"></div>' +
                '</div>' +
                '<div class="usage-breakdown-val">' +
                row.qty.toLocaleString() + ' <span class="usage-breakdown-pct">(' + pct + '%)</span>' +
                '</div>' +
                '</div>';
        }
        // F4.4 hotfix (2026-05-07): use replaceChildren via Range
        // contextual fragment to avoid bumping the innerHTML-assignment
        // ratchet (baseline 232; the prior bars-set-html shape regressed
        // to 233). Both forms run the HTML parser internally so safety
        // is identical; the ratchet is grep-based not security-based.
        const _range = document.createRange();
        _range.selectNodeContents(bars);
        const _frag = _range.createContextualFragment(html);
        bars.replaceChildren(_frag);
        _hydrateMvStyles(bars);
        section.classList.remove('hidden');
    })
        .catch(function (_e) {
        // Fail-quiet — the usage view is still useful without the
        // breakdown. Section stays hidden.
    });
}
function renderUsageView() {
    const container = document.getElementById('usage-panel-content');
    if (!container)
        return;
    // Anon-flash fix (2026-06-03): an authed user whose /api/auth/me hasn't
    // populated _authUser yet would flash the anon "Sign In to Track Your Usage"
    // state — a hard refresh only "fixed" it because auth resolved before this
    // paint. The JS-readable ol_csrf_hmac cookie is the canonical EARLY authed
    // signal (HttpOnly ol_session is invisible to JS — see
    // feedback_httponly_session_cookie_use_csrf_hmac). When it's present we treat
    // the user as authed and render the authed shell (which uses _billingData ||
    // defaults and hydrates async), never the sign-in prompt.
    var _hasAuthCookie = false;
    try {
        _hasAuthCookie = document.cookie.indexOf('ol_csrf_hmac=') !== -1;
    }
    catch (_e) { }
    // #12 CWA-CLS tune-down (2026-08-25, measured live): the 880px settled-
    // height reservation left the ANON sign-in state with 325px of dead space
    // at narrow widths (natural 555px @500w / 337px @1280w). The anon decision
    // is known HERE, in the same paint as the anon content, so the shorter
    // reservation rides the same frame -- no swap shift either way. Authed
    // keeps the full 880 (its billing content hydrates async and settles at
    // ~886px; that swap was the CWA 0.314 shifter the reservation fixed).
    var _usagePanelEl = document.getElementById('usage-panel-content');
    if (_usagePanelEl) {
        _usagePanelEl.classList.toggle('usage-panel--anon', !_authUser && !_hasAuthCookie);
    }
    if (!_authUser && !_hasAuthCookie) {
        // Unauthenticated state
        var tc = _getTierConfig();
        var _unauthCards = '';
        var _unauthColors = { free: 'color-brand', plus: 'color-blue-vivid', pro: 'color-amber', professional: 'color-gold' };
        // Audit 2026-09-24 #9: Power User ($29, 1,000 credits) is sold on /pricing
        // and accepted by checkout but had no card here. Same source as the others
        // (_getTierConfig: /api/billing/tiers, TIER_CONFIG).
        ['free', 'plus', 'pro', 'professional'].forEach(function (k) {
            var t = tc[k];
            if (!t)
                return;
            // SF-MONETIZATION-V3 / Usage&Billing mini-CYCLE 2026-05-15: the
            // subtitle was `display_limit` (the RETIRED lookup quota — e.g.
            // "20,000/mo" — misleading post-lookup-retirement). Now the
            // monthly bundled AI grant. Card copy unit = "AI credits"
            // (OWNER 2026-06-12, SUPERSEDES the 2026-05-15 "AI analyses"
            // GTM framing: "analyses" was the RETIRED lookup-quota vocabulary
            // and contradicted pricing.html / credit-meter / Your-Ledger /
            // the 429 copy, which all say credits).
            var _bcU = Number(t.bundled_credits) || 0;
            _unauthCards += '<div class="usage-tier-card">' +
                '<div class="usage-tier-card-name ' + (_unauthColors[k] || '') + '">' + escHtml(t.name).toUpperCase() + '</div>' +
                '<div class="usage-tier-card-price">$' + t.price_mo + (t.price_mo > 0 ? '<span class="tier-price-period">/mo</span>' : '') + '</div>' +
                '<div class="usage-tier-card-desc">' + (_bcU ? _bcU.toLocaleString() + ' AI credits/mo' : '') + '</div>' +
                '</div>';
        });
        // 2026-04-30 evening (auth-panels A5): unauth state migrated from
        // bespoke .usage-unauth-* class family to the canonical .ol-empty
        // shape via OLEmpty.render. The 3-tier grid is panel-specific so
        // it stays inline below the empty body; only the title + sub +
        // "no credit card" footer use the consolidated factory shape.
        var _unauthHeader;
        if (typeof window.OLEmpty !== 'undefined' && window.OLEmpty.render) {
            _unauthHeader = window.OLEmpty.render({
                title: 'Sign In to Track Your Usage',
                body: 'Monitor your research usage, manage your safety cap, and control your billing.',
            });
        }
        else {
            // Defensive fallback (canonical .ol-empty markup)
            _unauthHeader = '<div class="ol-empty">'
                + '<div class="ol-empty-title">Sign In to Track Your Usage</div>'
                + '<div class="ol-empty-body">Monitor your research usage, manage your safety cap, and control your billing.</div>'
                + '</div>';
        }
        container.innerHTML =
            _unauthHeader +
                '<div class="usage-tiers-grid">' + _unauthCards + '</div>' +
                '<div class="usage-unauth-cta">No credit card required to start</div>';
        return;
    }
    // Authenticated state -- use billing data or defaults
    // F4.1 (SF-23 audit 2026-05-07): both literal fallbacks (3000 in the
    // _billingData default + 1000 in the limit fallback) understated the
    // free-tier limit by 40-80%. Reads window.OL_FREE_TIER_LIMIT first,
    // then falls back to 5000 to stay consistent with TIER_CONFIG +
    // pricing.html public commitment.
    const _olFreeLimit = window.OL_FREE_TIER_LIMIT || 5000;
    // #17 fix: distinguish "billing not yet hydrated" (authed user, _billingData
    // still null while getBillingUsage is in flight — or after it failed / 429'd)
    // from a REAL free user. Without this the tier-dependent chrome defaults to
    // tier:'free' and mis-renders a paying user as "FREE / 0 questions / upgrade to
    // unlock" until the async re-render lands (fetchBillingData().then(render)
    // below) — and STICKS there if that fetch never resolves. Gate the badge + the
    // AI-credits readout on _hydrated so the unhydrated paint shows a neutral
    // loading state, never a false FREE.
    const _hydrated = _billingData != null;
    const data = _billingData || { tier: 'free', usage: 0, limit: _olFreeLimit, cap: 0, spent: 0.00, cap_reached: false, period_end: null };
    const tier = (data.tier || 'free').toLowerCase();
    const usage = data.usage || 0;
    const limit = data.limit || _olFreeLimit;
    const cap = data.cap != null ? data.cap : 20.00;
    const spent = data.spent || 0;
    const periodEnd = data.period_end;
    const daysLeft = _daysRemaining(periodEnd);
    const usagePct = Math.min(100, (usage / limit) * 100);
    const usageLevel = _usageLevel(usagePct);
    const capPct = cap > 0 ? Math.min(100, (spent / cap) * 100) : 0;
    const capLevel = _usageLevel(capPct);
    // OWNER 2026-09-24 "Developer = Power User + a monthly API allowance": a
    // Developer plan holder reads as their plan, never as a free Learner.
    const _planName = _mvAgentPlanName(data.agent_plan);
    const tierLabel = _hydrated
        ? (_planName ? _planName + ' (includes Power User)' : (data.tier_display || tier)).toUpperCase() : '...';
    const tierBadgeClass = _hydrated ? ('tier-badge-' + (tier === 'hobbyist' ? 'free' : tier)) : 'tier-badge-loading';
    let html = '';
    // Title + tier badge
    html += '<div class="usage-panel-title">' +
        '<span>USAGE & BILLING</span>' +
        '<span class="usage-tier-badge ' + tierBadgeClass + '">' + escHtml(tierLabel) + '</span>' +
        '</div>';
    // SF-MONETIZATION-V3 (2026-05-15): the retired lookup-credit meter +
    // pace projection were removed. Lookup accounting is dead
    // server-side (constants.py lookups_unlimited=True; §2.1 endpoints
    // weight 0; overage retired), so the rendered "0 / 20,000 lookups /
    // On track" was MISLEADING-not-vestigial UI. Replaced with the
    // OWNER-ratified plan §3.1 statement; AI Credits (below) is now the
    // panel's primary usage signal.
    html += '<div class="usage-section">' +
        '<div class="usage-section-label">Research</div>' +
        '<p class="usage-weight-note">Unlimited research on SEC filings, FRED, US Treasury, and FINRA data &mdash; included on every tier.</p>' +
        '</div>';
    // AI credit balance — shipped at top of the panel because users
    // looking at /usage often want to know "what do I have left for AI?"
    // before drilling into research-quota counters. credit_balance comes
    // from /api/billing/usage; falls back to 0 when not provisioned.
    // Free tier sees a "Top up to unlock AI" CTA so the section is never
    // a dead empty row. Paid tiers see balance + a Top-up shortcut.
    // F4.3 (SF-23 audit 2026-05-07): credit_balance is a COUNT of AI
    // questions, not a dollar amount. Pre-fix this rendered as
    // "$10.00 available for Ask AI conversations" — a free user read
    // it as a $10 cash balance they could spend on anything. Post-fix
    // the display is "10 questions" with a hover-explainer that 1
    // question = 1 credit. Math.round used because backend may return
    // a float during in-flight rounding (e.g., 9.5 if a half-credit
    // refund just landed); we round to the nearest whole question for
    // display.
    var creditBal = (data.credit_balance != null) ? Number(data.credit_balance) : 0;
    var creditCount = Math.max(0, Math.round(creditBal));
    var creditDisplay = _hydrated ? creditCount.toString() : '...';
    var creditUnit = creditCount === 1 ? 'question' : 'questions';
    // Usage&Billing mini-CYCLE 2026-05-15 (DESIGN+GTM consensus): the
    // live usage-vs-grant signal belongs HERE (the personal meter), not
    // on the tier comparison cards. Show the active tier's monthly
    // bundled grant as the denominator so the user sees what's left of
    // this month's allowance. Legacy tier keys mapped as elsewhere.
    var _aK = tier === 'hobbyist' ? 'free' : (tier === 'scale' || tier === 'institutional') ? 'pro' : tier === 'plus_trial' ? 'plus' : tier;
    var _aiGrant = Number((_getTierConfig()[_aK] || {}).bundled_credits) || 0;
    // BYOK relief valve (mini-CYCLE 2026-05-15, OWNER chose GTM option):
    // when the user is at/near the monthly grant ceiling (≤20% left),
    // surface a no-cost escape — run Ask AI on their own API key
    // (uncapped) — instead of only the pay-more path. GTM: converts
    // ceiling-anxiety into a free relief instead of a churn signal.
    // Gated to high-usage only so it is not pre-sale clutter. Routes to
    // the LLM & API Keys panel (data-action canonical app-renderers.ts:
    // 3171). Reuses the section's existing styled classes — no CSS add.
    var _aiLow = (_aiGrant > 0 && creditBal <= _aiGrant * 0.2);
    // Audit 2026-09-24 #9 (Settings -> Usage & Billing):
    //  (c) this read "255 of 200 monthly questions" -- a monthly grant is ADDED
    //      to the balance (carry-over), so the balance can exceed the grant and
    //      "X of <grant>" is not a fraction of anything. Two honest figures now:
    //      the balance you can spend, and what your plan adds each month.
    //  (b) a "Top up" / "Add credits" button re-opened this same view: there is
    //      no credit purchase (POST /api/billing/add-credits is admin-only). The
    //      only way to more monthly credits is a higher plan, so tiers below
    //      Power User get an upgrade button to the next personal tier; Power
    //      User and above get none.
    var _nextTierKey = { free: 'plus', plus: 'pro', pro: 'professional' }[_aK] || '';
    var _nextTier = _nextTierKey ? (_getTierConfig()[_nextTierKey] || {}) : {};
    var _nextGrant = Number(_nextTier.bundled_credits) || 0;
    var _nextName = _nextTier.name || '';
    var _grantLine = _aiGrant ? ' &middot; your plan adds ' + _aiGrant.toLocaleString() + ' each month' : '';
    html += '<div class="usage-section" title="1 AI question = 1 credit. Your plan adds its monthly credits to this balance each billing cycle.">' +
        '<div class="usage-section-label">AI Credits</div>' +
        '<div class="usage-cap-row">' +
        '<span class="usage-cap-value">' + creditDisplay + '</span>' +
        '<span class="usage-cap-limit">' + (!_hydrated
        ? 'Loading your plan…'
        : (creditBal > 0
            ? creditUnit + ' available for Ask AI' + _grantLine
            : 'questions left for Ask AI' + _grantLine)) + '</span>' +
        ((_hydrated && _nextTierKey && _nextName)
            ? '<button class="usage-cap-change-btn" data-action="start-checkout" data-tier="' + _nextTierKey + '" title="'
                + escHtml(_nextName) + (_nextGrant ? ' adds ' + _nextGrant.toLocaleString() + ' AI credits each month' : '') + '">'
                + 'More credits on ' + escHtml(_nextName) + '</button>'
            : '') +
        '</div>' +
        (_aiLow
            ? '<div class="usage-cap-row usage-byok-relief">' +
                '<span class="usage-cap-limit">Out of analyses? Run Ask AI on your own API key &mdash; uncapped.</span>' +
                '<button class="usage-cap-change-btn" data-action="toggle-api-keys-panel">Connect a key</button>' +
                '</div>'
            : '') +
        '</div>';
    // Safety cap — 2026-05-19 P0-3 (5-persona quorum BUILDER #6 + CHAOS + CHAMP):
    // ONLY render for metered users (AI agents on $0.01/call). For
    // subscription users (the vast majority) the entire `spent` value is
    // hard-coded to 0.0 server-side at routes_billing_fastapi.py:242 since
    // the SF-MONETIZATION-V3 lookup-overage retirement (2026-05-14), so
    // the panel rendered "$0.00 / $5.00 monthly cap" with a fake "Change Cap"
    // picker — silent lie / dead UI. CHAMP first-hour walkthrough: novice
    // user reads "$0.00" and concludes "I'm safe", a trust-cost from a
    // control that does nothing. Wrap fixes it: subscription users see no
    // Safety Cap section at all. `billing_mode` field already in the
    // response shape (routes_billing_fastapi.py:250 default 'monthly').
    if (data.billing_mode === 'metered') {
        html += '<div class="usage-section">' +
            '<div class="usage-section-label">Safety Cap</div>' +
            '<div class="usage-cap-row">' +
            '<span class="usage-cap-value">$' + spent.toFixed(2) + '</span>' +
            '<span class="usage-cap-limit">/ $' + cap.toFixed(2) + ' monthly cap</span>' +
            '<button class="usage-cap-change-btn" data-action="toggle-cap-options">Change cap</button>' +
            '</div>' +
            '<div class="usage-progress-track">' +
            '<div class="usage-progress-fill level-' + capLevel + ' mv-usage-fill" data-w="' + capPct.toFixed(1) + '"></div>' +
            '</div>' +
            '<div class="usage-cap-options" id="usage-cap-options">' +
            '<button class="usage-cap-opt' + (cap === 5 ? ' active' : '') + '" data-action="set-usage-cap" data-cap="5">$5</button>' +
            '<button class="usage-cap-opt' + (cap === 10 ? ' active' : '') + '" data-action="set-usage-cap" data-cap="10">$10</button>' +
            '<button class="usage-cap-opt' + (cap === 25 ? ' active' : '') + '" data-action="set-usage-cap" data-cap="25">$25</button>' +
            '<div class="usage-cap-custom">' +
            '<span class="usage-cap-dollar">$</span>' +
            '<input type="number" id="usage-cap-custom-input" placeholder="Custom" min="1" step="1" />' +
            '<button class="usage-cap-opt" data-action="set-custom-cap">SET</button>' +
            '</div>' +
            '</div>' +
            '</div>';
    }
    // F4.4 (SF-23 audit 2026-05-07): Activity breakdown — per-action
    // rollup populated lazily by /api/billing/usage/breakdown.
    // BILL-01 (UX/Billing Audit 2026-05-25) Option B (OWNER 2026-05-26):
    // labelled "AI Activity" not "Activity Breakdown" — the underlying
    // report_usage() is called from 12 AI-only sites (ai_chat, alerts,
    // PDF/CSV/XLSX export, ai_quiz_feedback, ai_practicum_review,
    // ai-chat-free, …); the prior label implied comprehensive tracking
    // and a user who ran 30 screener queries + 2 AI questions would see
    // "2 events" and think the panel was broken. Honest scoping → trust.
    html += '<div class="usage-section usage-breakdown-section hidden" id="usage-breakdown-section">' +
        '<div class="usage-section-label">AI Activity <span class="usage-breakdown-window">(last 30 days)</span></div>' +
        '<div id="usage-breakdown-bars" class="usage-breakdown-bars"></div>' +
        '<p class="usage-breakdown-note hidden" id="usage-breakdown-empty">No AI activity yet — your AI usage will appear here once you start asking questions or running quiz feedback.</p>' +
        // BILL-07 (UX/Billing Audit 2026-05-25, OWNER 2026-05-26): the
        // underlying usage cap is weighted (one AI chat counts as 10
        // units, a screener run as 50, a single ticker lookup as 1 —
        // see shared.py:ENDPOINT_TOKEN_WEIGHTS). The bar count is
        // event-level; the cap math is weighted-quantity-level. Surface
        // a single-line note so users who notice the divergence have
        // somewhere to go for the explanation.
        '<p class="usage-breakdown-weight-note">Heavier actions (screener, full company analysis) count more toward your monthly cap than quick ticker lookups.</p>' +
        '</div>';
    // SF-MONETIZATION-V3 (2026-05-15): the retired per-endpoint
    // weighted-multiplier explainer table was removed — the
    // lookup/weighted-quota model it described no longer exists
    // (constants.py lookups_unlimited=True; tier-1 endpoints weight 0).
    // No replacement. (Comment intentionally paraphrases the old label
    // so the test_usage_panel_no_lookup_model_contract source-grep pin
    // stays robust — same convention as the pg_record_price myth fix.)
    // Audit 5.3e: Billing state explanation
    var _billingState = data.billing_state || 'active';
    if (_billingState !== 'active') {
        var _stateInfo = {
            grace_period: { label: 'Grace Period', desc: 'Your payment failed. You have a few days to update your payment method before access is restricted.', action: 'Update payment in Manage Subscription below.' },
            suspended: { label: 'Suspended', desc: 'Your account is suspended due to unpaid invoices. Research features are disabled until payment is resolved.', action: 'Contact support or update payment to reactivate.' },
            disputed: { label: 'Payment Disputed', desc: 'A charge on your account was disputed. Access is limited while the dispute is being reviewed.', action: 'If this was not you, contact your bank. Otherwise, manage via Stripe portal below.' },
            cancelled: { label: 'Cancelled', desc: 'Your subscription has been cancelled. You can still use free-tier features.', action: 'Subscribe again anytime via the pricing tiers above.' },
        }[_billingState] || { label: _billingState, desc: '', action: '' };
        html += '<div class="usage-section usage-state-alert">' +
            '<div class="usage-section-label">Account Status: ' + escHtml(_stateInfo.label) + '</div>' +
            '<p>' + escHtml(_stateInfo.desc) + '</p>' +
            (_stateInfo.action ? '<p class="usage-state-action">' + escHtml(_stateInfo.action) + '</p>' : '') +
            '</div>';
    }
    // Tier overview (from centralized config)
    // 2026-04-30 evening (auth-panels A6): pull display name from canonical
    // window.TIER_DISPLAY_NAMES (hoisted in app.js) before falling back to
    // _getTierConfig().name — keeps the label invariant if the backend
    // tier config name field ever drifts ahead of the frontend rename.
    var tc = _getTierConfig();
    var _tdn = (typeof window !== 'undefined' && window.TIER_DISPLAY_NAMES) || {};
    var _tierColors = { free: 'var(--text-secondary)', plus: 'var(--blue-vivid)', pro: 'var(--amber)', professional: 'var(--gold-brand)' };
    // Audit 2026-09-24 #9(a): Power User added -- sold on /pricing, accepted by
    // checkout, previously missing here. Same source as the other three cards.
    const tiers = ['free', 'plus', 'pro', 'professional'].map(function (k) {
        var t = tc[k] || {};
        var _name = _tdn[k] || t.name || k;
        // desc: SF-MONETIZATION-V3 / mini-CYCLE 2026-05-15 — was the
        // RETIRED `display_limit` lookup quota; now the monthly bundled AI
        // grant. Copy unit "AI credits" (OWNER 2026-06-12, supersedes the
        // 2026-05-15 "AI analyses" framing — consistency with pricing/
        // meter/429 copy). Live usage is intentionally NOT shown on the
        // comparison cards (it lives in the AI Credits section below —
        // DESIGN: keep the 3-up row uniform, no Pattern-F per-card meter).
        var _bc = Number(t.bundled_credits) || 0;
        return { key: k, name: _name.toUpperCase(), price: t.price_mo ? ('$' + t.price_mo + '/mo') : '$0', price_yr: Number(t.price_yr) || 0, desc: (_bc ? _bc.toLocaleString() + ' AI credits/mo' : ''), color: _tierColors[k] || 'var(--text-muted)' };
    });
    // Map legacy tier names for display purposes
    const activeTierKey = tier === 'hobbyist' ? 'free' : tier === 'scale' || tier === 'institutional' ? 'pro' : tier === 'plus_trial' ? 'plus' : tier;
    html += '<div class="usage-section">' +
        '<div class="usage-section-label">Pricing Tiers</div>' +
        '<div class="usage-tiers-grid">';
    // Rank tiers so each card knows whether it's an upgrade or downgrade
    // relative to the active plan. User: "similar to the Upgrade button,
    // there should be an equivalent Downgrade button (we care about user
    // experience first)" — symmetric affordances on both sides of the
    // current plan, no dead tile on the left.
    // Ranks come from the server ladder mirror (tier-gate.ts OL-TIER-RANK-HELPERS,
    // middleware/auth.py _TIER_ORDER) so Power User (3), Advisor (2) and
    // Institutional (4) place correctly against the cards; the local table this
    // replaced had no professional/team/institutional_plus entry and ranked all
    // three as free.
    var _rankOf = function (k) {
        return typeof _olTierRankOf === 'function' ? _olTierRankOf(k)
            : ({ free: 0, hobbyist: 0, plus: 1, plus_trial: 1, pro: 2, scale: 2, institutional: 2, team: 2, professional: 3, institutional_plus: 4 }[k] || 0);
    };
    var _activeRank = _rankOf(activeTierKey);
    for (const t of tiers) {
        const isActive = _hydrated && (t.key === activeTierKey);
        var _tRank = _rankOf(t.key);
        var _ctaHtml = '';
        if (!_hydrated) {
            _ctaHtml = ''; // #17: don't mark a Current Plan or show Upgrade/Downgrade until the real tier is known
        }
        else if (isActive) {
            _ctaHtml = '<div class="tier-current-label mv-tier-current-label" data-fg="' + t.color + '">'
                + (_planName ? 'Included with ' + escHtml(_planName) : 'Current Plan') + '</div>';
        }
        else if (_planName && _tRank < _activeRank) {
            // The Developer plan confers this rank; there is no consumer plan to
            // step down to, so no Downgrade button (the portal would offer to
            // cancel the Developer subscription instead).
            _ctaHtml = '';
        }
        else if (_tRank > _activeRank) {
            _ctaHtml = '<button class="usage-tier-upgrade-btn" data-action="start-checkout" data-tier="' + t.key + '">Upgrade</button>';
            // D-5 (#14, 2026-08-10): annual is now sellable in-app — an EXPLICIT
            // second button with the full yearly price disclosed. COUNSEL posture
            // preserved from pricing-page.ts:62 (UCPD Annex I item 22 / DSA Art 25
            // / FTC §5): monthly stays the visually-primary un-preselected
            // default; annual is never pre-selected, it is its own click. The
            // muted downgrade-btn class is reused purely for its secondary
            // styling (no new CSS selector; DS-14).
            if (t.price_yr > 0) {
                _ctaHtml += '<button class="usage-tier-downgrade-btn" data-action="start-checkout" data-tier="' + t.key + '" data-period="annual">Annual &mdash; $' + t.price_yr + '/yr (save 25%)</button>';
            }
        }
        else if (_tRank === _activeRank) {
            // Same rank, different product (an Advisor seat vs the Investor card):
            // neither an upgrade nor a downgrade, so no button.
            _ctaHtml = '';
        }
        else {
            // Downgrade routes through Stripe's customer portal so the
            // billing cycle, proration, and end-of-period scheduling are
            // all owner-controlled. Going to free === cancel-at-period-end
            // in Stripe's UI, which is the correct default.
            _ctaHtml = '<button class="usage-tier-downgrade-btn" data-action="open-billing-portal" data-tier="' + t.key + '">Downgrade</button>';
        }
        html += '<div class="usage-tier-card' + (isActive ? ' tier-active' : '') + '">' +
            '<div class="usage-tier-card-name mv-tier-card-name" data-fg="' + (isActive ? t.color : 'var(--text-muted)') + '">' + t.name + '</div>' +
            '<div class="usage-tier-card-price' + (!isActive ? ' opacity-half' : '') + '">' + t.price + '</div>' +
            '<div class="usage-tier-card-desc">' + t.desc + '</div>' +
            _ctaHtml +
            '</div>';
    }
    html += '</div></div>';
    // Manage Subscription button -- only for paid tiers
    if (tier !== 'free' && tier !== 'hobbyist' && tier !== 'plus_trial') {
        html += '<div class="usage-section text-center pt-4">' +
            '<button data-action="open-billing-portal" class="manage-sub-btn">' +
            'Manage subscription &rarr;' +
            '</button>' +
            '<div class="manage-sub-hint">' +
            'Upgrade, downgrade, switch billing cycle, update payment, or cancel' +
            '</div>' +
            '</div>';
    }
    else if (tier === 'plus_trial') {
        // A3 (2026-05-13 Mobile/Brand/Billing audit follow-on): mid-trial
        // users previously saw no Manage Subscription surface — the trial-
        // end day arrived as a 402 toast with no warning earlier than the
        // 48h grace banner. Surface days-remaining + the portal CTA so
        // users can switch to annual, change tier early, or cancel before
        // expiry instead of being surprised.
        var _trialEndStr = data.trial_end;
        var _trialDaysLeft = null;
        if (_trialEndStr) {
            var _trialDate = new Date(_trialEndStr);
            if (!isNaN(_trialDate.getTime())) {
                _trialDaysLeft = Math.max(0, Math.ceil((_trialDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
            }
        }
        var _trialStatusCopy;
        if (_trialDaysLeft != null) {
            _trialStatusCopy = 'Trial status: ' + _trialDaysLeft + ' day' + (_trialDaysLeft === 1 ? '' : 's') + ' remaining → Plus';
        }
        else {
            _trialStatusCopy = 'Trial status: active → Plus';
        }
        html += '<div class="usage-section text-center pt-4">' +
            '<div class="trial-status-pill">' + _trialStatusCopy + '</div>' +
            '<button data-action="open-billing-portal" class="manage-sub-btn">' +
            'Manage subscription &rarr;' +
            '</button>' +
            '<div class="manage-sub-hint">' +
            'Switch billing cycle, change tier, update payment, or cancel before trial ends' +
            '</div>' +
            '</div>';
    }
    // Email Preferences section
    html += '<div class="usage-section usage-email-section">' +
        '<div class="usage-section-label">Email Preferences</div>' +
        '<div id="email-prefs-content" class="email-prefs-wrap">' +
        'Loading...' +
        '</div>' +
        '</div>';
    container.innerHTML = html;
    _hydrateMvStyles(container);
    // Load email preferences after DOM is set
    _loadEmailPreferences();
    // F4.4 (SF-23 audit 2026-05-07): hydrate the activity-breakdown
    // section asynchronously. The skeleton is in place; this fetch +
    // render is the only thing keeping it hidden by default.
    _renderUsageBreakdown();
    // Fetch fresh data if we don't have it yet.
    // Never-hang (2026-06-29): a transient /api/billing/usage failure — e.g. a
    // 502 during a Render deploy-restart window, or a network blip — used to
    // leave the panel stuck on "Loading your plan…" forever. fetchBillingData()
    // catches + returns null, so `if (d)` skipped the re-render AND
    // _startBillingRefresh() (armed only on the success path) never started the
    // 5-min self-heal tick. Now: on a failed first fetch we retry with a short
    // bounded backoff (covers the ~30-60s deploy window so the user recovers in
    // seconds), and arm the refresh loop regardless as a longer backstop.
    // (feedback_fundamentals_thin_pg_shadows_rich_shape — frontend never-hang.)
    //
    // OWNER prod-QA 2026-07-15: the `&& _authUser` precondition ALSO left the
    // panel stuck. renderUsageView paints before /api/auth/me resolves, so at
    // first paint `_authUser` is still falsy → the hydrate fetch was SKIPPED and
    // nothing re-triggered it when auth landed → "Loading your plan…" forever
    // (the credit meter dodged this via its own timer-driven fetch). /api/billing/
    // usage is credential-gated server-side and the renderer already handles the
    // anon shape (authenticated:false → free-tier CTA), so gate ONLY on
    // !_billingData — an auth-not-ready-yet authed user now hydrates on arrival.
    if (!_billingData) {
        var _bdAttempt = 0;
        var _bdBackoff = [3000, 6000, 12000];
        var _bdTryHydrate = function () {
            fetchBillingData().then(function (d) {
                if (d) {
                    renderUsageView();
                    return;
                }
                _startBillingRefresh(); // arm the 5-min self-heal backstop (OLPolling de-dups by key)
                if (_bdAttempt < _bdBackoff.length) {
                    setTimeout(_bdTryHydrate, _bdBackoff[_bdAttempt++]);
                }
            });
        };
        _bdTryHydrate();
    }
}
// ═══ TRIAL DEGRADATION — GOLD BADGES ═══
/**
 * Show a gold badge on a container indicating the user's trial included this feature.
 * Used when a 403 is returned with requiredTier and the user's trial recently ended.
 */
function showGoldBadge(container, requiredTier) {
    if (!container || container.querySelector('.trial-badge'))
        return;
    const badge = document.createElement('div');
    badge.className = 'trial-badge';
    badge.innerHTML = '<span class="trial-badge-icon">\u2605</span>' +
        'Your trial included this feature' +
        '<a href="/?upgrade=' + encodeURIComponent(requiredTier || 'plus') + '" class="trial-badge-link">Upgrade to ' +
        escHtml((requiredTier || 'Plus').charAt(0).toUpperCase() + (requiredTier || 'plus').slice(1)) +
        '</a>';
    container.style.position = 'relative';
    container.prepend(badge);
}
/**
 * Show a standard upgrade prompt when feature is gated and no recent trial.
 */
function showUpgradePrompt(container, requiredTier) {
    if (!container || container.querySelector('.upgrade-gate-prompt'))
        return;
    const prompt = document.createElement('div');
    prompt.className = 'upgrade-gate-prompt';
    prompt.innerHTML = '<div class="upgrade-gate-title">Premium Feature</div>' +
        '<div class="upgrade-gate-desc">This feature requires ' +
        escHtml((requiredTier || 'Plus').charAt(0).toUpperCase() + (requiredTier || 'plus').slice(1)) +
        ' tier or higher.</div>' +
        '<a href="/?upgrade=' + encodeURIComponent(requiredTier || 'plus') + '" class="upgrade-gate-btn">View Plans</a>';
    container.style.position = 'relative';
    container.prepend(prompt);
}
/**
 * Handle a feature-gate response (402 Payment Required or legacy 403).
 * 402 is the canonical tier-gate status after Phase 2 backend hardening.
 * 403 is kept for backward compat with any lingering string-detail endpoints.
 * @param {Response} resp - the fetch Response
 * @param {HTMLElement} [container] - optional element to show badge/prompt on
 * @returns {boolean} true if the response was a feature gate (caller should stop processing)
 */
async function handleFeatureGate(resp, container) {
    if (resp.status !== 402 && resp.status !== 403)
        return false;
    try {
        const data = await resp.clone().json();
        if (!data.requiredTier)
            return false;
        // Check if user recently had a trial
        const trialEnd = OLStorage.getString('ol_trial_end', null);
        const isRecentTrial = trialEnd && (Date.now() < new Date(trialEnd).getTime() + 14 * 86400000);
        if (container) {
            if (isRecentTrial) {
                showGoldBadge(container, data.requiredTier);
            }
            else {
                showUpgradePrompt(container, data.requiredTier);
            }
        }
        else {
            // No container -- just show a toast
            if (isRecentTrial) {
                showToast('Your trial included this feature. Upgrade to keep access.', 'warning', 5000);
            }
            else {
                showToast(data.error || 'This feature requires ' + data.requiredTier + ' tier', 'warning', 4000);
            }
        }
        return true;
    }
    catch (_) {
        return false;
    }
}
// Store trial end date when billing data is fetched (used for gold badge logic)
(function _patchFetchBillingForTrial() {
    const _origFetchBilling = fetchBillingData;
    fetchBillingData = async function () {
        const result = await _origFetchBilling();
        if (result && result.trial_end) {
            OLStorage.setString('ol_trial_end', result.trial_end);
        }
        return result;
    };
})();
// ═══ Email Preferences ═══
var _emailPrefs = null;
async function _loadEmailPreferences() {
    const container = document.getElementById('email-prefs-content');
    if (!container || !_authUser)
        return;
    try {
        const res = await fetch('/api/settings/email', { credentials: 'same-origin' });
        if (!res.ok) {
            container.innerHTML = '<span class="color-neutral">Sign in to manage email preferences</span>';
            return;
        }
        _emailPrefs = await res.json();
        _renderEmailPreferences();
    }
    catch (e) {
        container.innerHTML = '<span class="color-neutral">Could not load email preferences</span>';
    }
}
function _renderEmailPreferences() {
    const container = document.getElementById('email-prefs-content');
    if (!container || !_emailPrefs)
        return;
    const configured = _emailPrefs.email_configured;
    const userEmail = _emailPrefs.user_email || '';
    let html = '';
    if (userEmail) {
        html += '<div class="email-deliver-info">' +
            'Delivering to: <span class="color-text-primary">' + escHtml(userEmail) + '</span>' +
            '</div>';
    }
    if (!configured) {
        html += '<div class="email-not-configured">' +
            '<span class="email-not-configured-title">Email delivery not configured</span>' +
            '<div class="email-not-configured-desc">Set EMAIL_API_KEY environment variable to enable email digests.</div>' +
            '</div>';
    }
    // Toggle: Market Close Brief. 2026-06-12 AI-credits CYCLE: "Daily
    // Morning Brief — 6:30 AM" was stale post the 06-04 Market Close
    // retime — third hidden sibling of this copy (settings-panel +
    // signup checkbox fixed in 609cb852).
    html += _emailToggleRow('email_daily', 'Market Close Brief', 'Where the market and your watchlist closed &mdash; after each close', _emailPrefs.email_daily);
    // Toggle: Weekly Portfolio Recap
    html += _emailToggleRow('email_weekly', 'Weekly Portfolio Recap', 'Performance vs S&P, sector drift, top/bottom movers &mdash; Saturday 8 AM ET', _emailPrefs.email_weekly);
    // Toggle: Alert Emails
    html += _emailToggleRow('email_alerts', 'Alert Emails', 'Price targets, earnings surprises, 8-K filings', _emailPrefs.email_alerts);
    container.innerHTML = html;
}
// Sub-options for each email category (all default ON when parent is enabled)
var _emailSubOptions = {
    email_daily: [
        { key: 'daily_portfolio_movers', label: 'Portfolio movers' },
        { key: 'daily_earnings', label: 'Earnings calendar' },
        { key: 'daily_market_context', label: 'Market context & macro' },
        { key: 'daily_watchlist', label: 'Watchlist updates' },
    ],
    email_weekly: [
        { key: 'weekly_performance', label: 'Performance vs S&P' },
        { key: 'weekly_sector_drift', label: 'Sector drift analysis' },
        { key: 'weekly_top_bottom', label: 'Top/bottom movers' },
        { key: 'weekly_dividends', label: 'Upcoming dividends' },
    ],
    email_alerts: [
        { key: 'alert_price_targets', label: 'Price target alerts' },
        { key: 'alert_earnings', label: 'Earnings surprises' },
        { key: 'alert_8k', label: '8-K filings' },
        { key: 'alert_insider', label: 'Insider transactions' },
        { key: 'alert_analyst', label: 'Analyst rating changes' },
    ],
};
function _emailToggleRow(key, label, desc, isOn) {
    var checkedAttr = isOn ? 'checked' : '';
    var dimCls = isOn ? '' : ' ol-email-row-dim';
    var html = '<div class="email-toggle-row' + dimCls + '">' +
        '<div class="email-toggle-info">' +
        '<div class="email-toggle-label">' + label + '</div>' +
        '<div class="email-toggle-desc">' + desc + '</div>' +
        '</div>' +
        '<label class="email-toggle-switch">' +
        '<input type="checkbox" ' + checkedAttr + ' data-change-action="toggle-email-pref" data-pref-key="' + escHtml(key) + '" ' +
        'class="email-toggle-input">' +
        '<span class="email-toggle-track ' + (isOn ? 'email-toggle-track--on' : 'email-toggle-track--off') + '"></span>' +
        '<span class="email-toggle-thumb ' + (isOn ? 'email-toggle-thumb--on' : 'email-toggle-thumb--off') + '"></span>' +
        '</label>' +
        '</div>';
    // Sub-options panel (shown only when parent is ON)
    var subs = _emailSubOptions[key];
    if (subs && isOn) {
        html += '<div class="email-sub-options">';
        for (var i = 0; i < subs.length; i++) {
            var sub = subs[i];
            var subOn = _emailPrefs[sub.key] !== false; // default true when parent is on
            html += '<label class="email-sub-row">' +
                '<span class="email-sub-label">' + escHtml(sub.label) + '</span>' +
                '<input type="checkbox" ' + (subOn ? 'checked' : '') + ' data-change-action="toggle-email-pref" data-pref-key="' + escHtml(sub.key) + '" class="email-sub-input">' +
                '</label>';
        }
        html += '</div>';
    }
    return html;
}
async function _toggleEmailPref(key, value) {
    try {
        const csrf = _getCsrfToken();
        const res = await fetch('/api/settings/email', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
            body: JSON.stringify({ [key]: value }),
        });
        if (res.ok) {
            const data = await res.json();
            _emailPrefs = { ..._emailPrefs, ...data };
            _renderEmailPreferences();
        }
        else {
            // Revert on failure
            if (_emailPrefs)
                _emailPrefs[key] = !value;
            _renderEmailPreferences();
        }
    }
    catch (e) {
        if (_emailPrefs)
            _emailPrefs[key] = !value;
        _renderEmailPreferences();
    }
}
// ═══ BETA LABEL TOGGLE ═══
(function () {
    const show = OLStorage.getString('showBetaLabel', null) !== 'false';
    const el = document.getElementById('beta-label-topbar');
    if (el && !show)
        el.classList.add('hidden');
})();
function _betaLabelClick(e) {
    e.stopPropagation();
    const el = document.getElementById('beta-label-topbar');
    if (!el)
        return;
    // Remove existing tooltip if any
    const existing = document.getElementById('beta-tooltip');
    if (existing) {
        existing.remove();
        return;
    }
    // Create tooltip
    const tip = document.createElement('div');
    tip.id = 'beta-tooltip';
    tip.className = 'csp-tooltip-abs';
    tip.innerHTML = '<div class="beta-tip-text">Oxford Ledge is in beta.<br>Click below to hide this label.</div>' +
        '<button data-action="beta-dismiss" class="beta-dismiss-btn">Hide beta label</button>';
    el.appendChild(tip);
    // Close on outside click
    setTimeout(() => {
        document.addEventListener('click', function _betaClose(ev) {
            if (!tip.contains(ev.target) && ev.target !== el) {
                tip.remove();
                document.removeEventListener('click', _betaClose);
            }
        });
    }, 0);
}
function _betaDismiss() {
    OLStorage.setString('showBetaLabel', 'false');
    const el = document.getElementById('beta-label-topbar');
    if (el)
        el.classList.add('hidden');
    const tip = document.getElementById('beta-tooltip');
    if (tip)
        tip.remove();
}
// ── AUTH BLOCK EXTRACTED ────────────────────────────────────────────
// NH9 step 2 (2026-05-07): the auth handlers (authToggle / authOpenModal /
// authSubmitSignin / authSubmitRegister / authCheckSession / OAuth /
// CSRF helpers / Terms re-acceptance modal / billing redirect handler)
// were moved to static/js/auth-handlers.ts so they can load as a
// pre-bundle <script defer> tag (R1 mitigation in
// docs/plans/NH9_BUNDLE_APP_SPLIT_BOOT_AUDIT.md §6.1). All names remain
// global (var / function declarations at script top-level), so the rest
// of milestones-view + every cross-chunk consumer still resolves them.
// ────────────────────────────────────────────────────────────────────
//# sourceMappingURL=milestones-view.js.map
;
// ═══ dropdown-handlers.js ═══
;"use strict";
// §DROPDOWN ════════════════════════════════════════════════════════════════════
// ═══ DROPDOWN UX ENHANCEMENTS: Hover Intent + Right-Opening + Numeric Shortcuts ═══
//
// TS Migration Phase 2 PR 26 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; dropdown-handlers.js is the build
// artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// Hover-intent + numeric 1-9 shortcuts for the trade / share
// dropdowns.
//
// SF-23 vestige removed 2026-05-17: the #more-dropdown-* wiring
// (hover-intent on #more-dropdown-wrap, _checkMoreDropdownViewport,
// _injectNumericBadges, the toggleMoreDropdown monkey-patch, the
// numeric-key + resize listeners targeting #more-dropdown) drove the
// deleted topbar markup (gone 2026-05-07, Phase C). The live
// .trade-dropdown-wrap / #alert-bell-wrap hover-intent and the
// trade/share numeric + Escape blocks are preserved unchanged.
(function () {
    'use strict';
    const _canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function setupHoverIntent(wrapSelector, openClass, openDelay, closeDelay) {
        if (!_canHover)
            return;
        const wrap = typeof wrapSelector === 'string'
            ? document.querySelector(wrapSelector)
            : wrapSelector;
        if (!wrap)
            return;
        let _openTimer = null;
        let _closeTimer = null;
        const od = openDelay || 200;
        const cd = closeDelay || 150;
        wrap.addEventListener('mouseenter', function () {
            if (_closeTimer)
                clearTimeout(_closeTimer);
            _openTimer = setTimeout(function () {
                wrap.classList.add('hover-open');
                if (openClass)
                    wrap.classList.add(openClass);
            }, od);
        });
        wrap.addEventListener('mouseleave', function () {
            if (_openTimer)
                clearTimeout(_openTimer);
            _closeTimer = setTimeout(function () {
                wrap.classList.remove('hover-open');
                if (openClass)
                    wrap.classList.remove(openClass);
            }, cd);
        });
    }
    function _initHoverDropdowns() {
        // SF-23 vestige removed 2026-05-17: setupHoverIntent('#more-dropdown-wrap', ...).
        document.querySelectorAll('.trade-dropdown-wrap').forEach(function (wrap) {
            setupHoverIntent(wrap, null, 200, 150);
        });
        setupHoverIntent('#alert-bell-wrap', null, 250, 200);
    }
    // SF-23 vestige removed 2026-05-17: _checkMoreDropdownViewport,
    // the toggleMoreDropdown monkey-patch + DropdownPatchWindow, and
    // _injectNumericBadges + the numeric-key listener that all targeted
    // the deleted #more-dropdown-* markup.
    // Numeric shortcuts for trade/share dropdowns
    document.addEventListener('keydown', function (e) {
        const tradeDd = document.getElementById('trade-dropdown');
        if (tradeDd && tradeDd.classList.contains('show')) {
            const num = parseInt(e.key, 10);
            if (num >= 1 && num <= 9 && !e.ctrlKey && !e.metaKey && !e.altKey) {
                const tag = (document.activeElement || {}).tagName;
                if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT')
                    return;
                const links = tradeDd.querySelectorAll('a[data-broker]');
                if (num <= links.length) {
                    e.preventDefault();
                    e.stopPropagation();
                    links[num - 1].click();
                }
            }
        }
        const shareDd = document.getElementById('hero-share-dropdown');
        if (shareDd && shareDd.classList.contains('show')) {
            const num2 = parseInt(e.key, 10);
            if (num2 >= 1 && num2 <= 9 && !e.ctrlKey && !e.metaKey && !e.altKey) {
                const tag2 = (document.activeElement || {}).tagName;
                if (tag2 === 'INPUT' || tag2 === 'TEXTAREA' || tag2 === 'SELECT')
                    return;
                const items = shareDd.querySelectorAll('a, button[data-action]');
                if (num2 <= items.length) {
                    e.preventDefault();
                    e.stopPropagation();
                    items[num2 - 1].click();
                }
            }
        }
    });
    // Add Escape for trade and share dropdowns too.
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            const tradeDd = document.getElementById('trade-dropdown');
            if (tradeDd && tradeDd.classList.contains('show')) {
                tradeDd.classList.remove('show');
            }
            const shareDd = document.getElementById('hero-share-dropdown');
            if (shareDd && shareDd.classList.contains('show')) {
                shareDd.classList.remove('show');
            }
        }
    });
    // ── INIT ──
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _initHoverDropdowns);
    }
    else {
        _initHoverDropdowns();
    }
    // SF-23 vestige removed 2026-05-17: the window-resize listener that
    // re-ran _checkMoreDropdownViewport on the deleted #more-dropdown-wrap.
})();
//# sourceMappingURL=dropdown-handlers.js.map
;
// ═══ mobile-helpers.js ═══
;"use strict";
// §MOBILE ══════════════════════════════════════════════════════════════════════
//
// TS Migration Phase 2 PR 32 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; mobile-helpers.js is the build
// artifact produced by `./node_modules/.bin/tsc -p tsconfig.build.json`.
//
// Mobile set-view delegated-action handlers (More sheet + auth dropdown).
// Top-level fns called by inline data-action handlers.
// Legacy `_syncMobileBottomNav` + `_bottomTabViews` + `_moreSheetViews`
// retired 2026-05-28 per SHIP-5 Phase 2 sub-slice 2g
// (docs/board/audit/2026-05-28_DESIGN_ship5_phase2_scoping.md §2g).
// The new bottom-tab chrome at
// static/js/product/chrome/bottom-tab.ts (`#ol-bottom-tab`) owns its
// own active-state sync via a setView() wrapper (Phase-1 pattern at
// bottom-tab.ts:223-240). The legacy `#mobile-bottom-nav` markup was
// removed from dashboard.html in the same commit. Contract test:
// tests/test_ship5_phase2_2g_legacy_retire_contract.py pins
// non-reintroduction.
// Mobile overflow "More" sheet (`_toggleMobileMoreSheet` / `_closeMobileMoreSheet`
// + focus-trap + Escape/click-outside listeners) RETIRED 2026-05-31 (SHIP-5
// Phase 2 sub-slice 2g completion). The sheet was orphaned when its opener (the
// legacy bottom bar) was removed 2026-05-28; its views are reachable via the
// hamburger feature-sidecar. Markup + mobile-nav.css deleted in the same commit.
// Ticker "row-2 collapse" bottom sheet (`_openTickerSheet` / `_closeTickerSheet`
// / `_renderTickerSheetChips` / `_tickerSheetAdd` + `_syncTickerRow2Btn` +
// the `#ticker-row2-btn` opener) RETIRED 2026-07-06 (#47 wave A2). The
// `#ticker-sheet*` + `#ticker-row2-btn` markup was already gone from
// dashboard.html so every getElementById-guarded driver entry silently
// no-oped; the delete removes the dead driver + its app-renderers.ts
// action-map entries. Contract test: tests/test_mobile_nav_47_contract.py
// pins non-reintroduction.
// 2g (2026-05-28): the setView wrap that synced the legacy
// `#mobile-bottom-nav` active state was retired with the legacy chrome.
// The new `#ol-bottom-tab` (bottom-tab.ts) installs its own setView
// wrap (sigil `_olBottomTabPatched`). The delegated-action handlers
// for `set-view`, `set-view-close-more`, and `set-view-close-auth-dd`
// remain — the More sheet + auth dropdown still depend on them — but
// now invoke the (un-sync-wrapped) setView directly.
(function () {
    const w = window;
    const _origSetView = w.setView || setView;
    if (typeof _origSetView !== 'function')
        return;
    if (typeof _delegatedActions === 'undefined')
        return;
    _delegatedActions['set-view'] = function (e) {
        const t = e.target;
        const closest = t.closest('[data-action]');
        if (closest)
            _origSetView(closest.dataset.view || '');
    };
    _delegatedActions['set-view-close-more'] = function (e) {
        const t = e.target;
        const closest = t.closest('[data-action]');
        if (closest)
            _origSetView(closest.dataset.view || '');
        if (typeof w.closeMoreDropdown === 'function')
            w.closeMoreDropdown();
    };
    _delegatedActions['set-view-close-auth-dd'] = function (e) {
        const t = e.target;
        const closest = t.closest('[data-action]');
        if (closest)
            _origSetView(closest.dataset.view || '');
        if (typeof w.authCloseDropdown === 'function')
            w.authCloseDropdown();
    };
})();
//# sourceMappingURL=mobile-helpers.js.map
;
// ═══ webmcp.js ═══
;"use strict";
/**
 * AGENT-7 P1 — WebMCP bridge (navigator.modelContext), catalog-driven.
 *
 * Registers Oxford Ledge's READ-ONLY tools with an in-browser AI agent, so an agent operating
 * on oxfordledge.com can call site capabilities with the user's OWN session instead of scraping
 * the DOM. The tool list is driven off the server catalog (/api/mcp/tools.json) — no
 * hand-maintained mirror; add a tool server-side and it appears here for free. Each tool executes
 * a SAME-ORIGIN POST to /api/mcp/tool, which enforces origin + tier + rate limits SERVER-SIDE. This
 * client registration is UX-only, exactly like tier-gate.js; the server is the gate, the client
 * never is.
 *
 * P1 policy (OWNER 2026-07-04): register the FULL advertised catalog — including tier-gated tools
 * (register-and-402: the agent sees the capability + how to unlock it; the server returns the 402
 * on call). READ-ONLY guard below excludes any mutating tool: write/portfolio tools are P2 and MUST
 * go through the CSRF-protected route, never this read shim.
 *
 * navigator.modelContext is an unratified W3C CG proposal with NO native browser support today
 * (extension/polyfill only). On any browser without it this module is a silent no-op: no UI, no
 * network (the catalog fetch is behind the feature-detect), no DOM, no CSP change. Plan:
 * docs/plans/AGENT7_WEBMCP.md.
 */
(function () {
    "use strict";
    var w = window;
    if (w.__OL_WEBMCP_LOADED) {
        return;
    }
    w.__OL_WEBMCP_LOADED = true;
    // READ-ONLY guard: skip any mutating tool. The /api/mcp/tool shim has no CSRF
    // token, so a write MUST NOT be registered through it — the server now also
    // refuses a cookie-authenticated write there, but this bridge should not even
    // offer one.
    //
    // The prefix-only form of this regex (/^(add|create|...)_/) MISSED
    // `reading_list_annotate` — a real per-user WRITE that shipped in the catalog
    // (SF-MCP-WRITE Phase 2) and sailed past a leading-verb test, which is one of
    // the three things that put a write on this shim (2026-08-08 CSRF review). The
    // comment here used to say "the current catalog is all reads"; it was not.
    // Widened to match a verb ANYWHERE in the name — the SAME pattern the sibling
    // catalog bridge (webmcp-tools.ts) already documents by naming this exact
    // `reading_list_annotate` trap.
    var MUTATING_RE = /(^|_)(add|create|save|delete|update|set|remove|edit|import|reset|cancel|annotate|rename|archive|submit|place|order|post|put|write)(_|$)/i;
    // Same-origin call to the MCP execution shim. credentials:'same-origin' carries the session
    // cookie so the SERVER-SIDE tier gate applies. The server response is surfaced FAITHFULLY to the
    // agent — including the 402 tier-gate and 429 rate-limit envelopes — so a gated tool teaches the
    // agent "this needs Plus" / "slow down" instead of a swallowed error.
    function callTool(name, args) {
        var body = JSON.stringify({ tool: name, arguments: args || {} });
        // Raw same-origin fetch (not window.OLApi): this idle-loaded chunk cannot assume OLApi is
        // present at call time (module-top-global-race); a same-origin relative fetch already carries
        // the session cookie via credentials:'same-origin'.
        return fetch("/api/mcp/tool", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: body,
        }).then(function (resp) {
            return resp.json().catch(function () { return null; }).then(function (data) {
                if (!resp.ok) {
                    return { error: true, status: resp.status, detail: data || (resp.status + " " + resp.statusText) };
                }
                return data;
            });
        });
    }
    function registerFromCatalog(tools) {
        var mc = navigator.modelContext;
        if (!mc) {
            return;
        }
        var defs = [];
        for (var i = 0; i < tools.length; i++) {
            var spec = tools[i];
            if (!spec || !spec.name) {
                continue;
            }
            // M-25 (2026-09-01 MCP CYCLE audit): the catalog's
            // `annotations.readOnlyHint` is the PRIMARY read-only gate — it is
            // derived server-side from the dispatcher's own `is_write` flag
            // (tests/test_mcp_tool_catalog_readonly_tripwire_contract.py pins the
            // derivation), so a future write named `ol_flag_issuer` is excluded
            // even though no verb in MUTATING_RE matches it. The name denylist
            // stays as the belt-and-suspenders FALLBACK for a catalog entry that
            // carries no boolean hint (an older cached catalog, a proxy that
            // strips annotations): with no hint we judge the name, exactly as
            // before.
            var ann = spec.annotations;
            var readOnlyHint = (ann && typeof ann.readOnlyHint === "boolean") ? ann.readOnlyHint : null;
            if (readOnlyHint === false) {
                continue;
            } // catalog says WRITE — never on this CSRF-less shim
            if (readOnlyHint === null && MUTATING_RE.test(spec.name)) {
                continue;
            } // no hint: name fallback
            defs.push({
                name: spec.name,
                description: spec.description || "",
                inputSchema: spec.input_schema || spec.inputSchema || { type: "object", properties: {} },
                execute: (function (toolName) {
                    return function (args) { return callTool(toolName, args); };
                })(spec.name),
            });
        }
        if (!defs.length) {
            return;
        }
        // AGENT-7 P1.1 (2026-07-05): the WebMCP proposal moved from per-tool
        // registerTool() to provideContext({tools}) (Chrome EPP shape — the shape
        // agent-readiness scanners detect). Prefer the CURRENT shape; keep the
        // older per-tool call as the fallback so early-adopter extensions that
        // shipped registerTool keep working. Same read-only catalog either way.
        if (typeof mc.provideContext === "function") {
            try {
                mc.provideContext({ tools: defs });
                return;
            }
            catch (_e) { /* fall through */ }
        }
        if (typeof mc.registerTool === "function") {
            for (var j = 0; j < defs.length; j++) {
                try {
                    mc.registerTool(defs[j]);
                }
                catch (_e2) { /* one bad registration must not break the rest */ }
            }
        }
    }
    // Fetch the public tool catalog (same-origin) and register every read tool. Runs only when the
    // API is present (see feature-detect below), so on today's browsers this fetch never fires.
    function loadAndRegister() {
        fetch("/api/mcp/tools.json", { credentials: "same-origin" })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
            var tools = data && data.tools;
            if (Array.isArray(tools)) {
                registerFromCatalog(tools);
            }
        })
            .catch(function () { });
    }
    // Feature-detect FIRST: if the API is absent (every stable browser today, natively), do nothing
    // and cost nothing — never touch the DOM or the network. Either API shape
    // counts (provideContext = current spec/Chrome EPP; registerTool = the
    // earlier proposal this bridge originally shipped against).
    if (typeof navigator === "undefined" ||
        !navigator.modelContext ||
        (typeof navigator.modelContext.provideContext !== "function" &&
            typeof navigator.modelContext.registerTool !== "function")) {
        return;
    }
    // Register off a DOM/idle callback — never at module top-level (module-top-global-race).
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", loadAndRegister, { once: true });
    }
    else {
        loadAndRegister();
    }
})();
//# sourceMappingURL=webmcp.js.map
;